(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8007],{

/***/ 87156:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/city/[...slug]",
      function () {
        return __webpack_require__(5402);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2248);
/* harmony import */ var _LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63267);
/* harmony import */ var _LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var LuggageButtonComponent = function(param) {
    var sizeStepper = param.sizeStepper, setSizeStepper = param.setSizeStepper, count = param.count, buttonStyle = param.buttonStyle;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().stepper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "".concat((_LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().countDownButton), " ").concat(buttonStyle),
                onClick: function() {
                    return setSizeStepper(sizeStepper - 1);
                },
                disabled: sizeStepper > count || sizeStepper === 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/stepper_decrement_icon.svg",
                    alt: t("META.STEPPER_DECREMENT_ICON"),
                    width: 14,
                    height: 3
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().count),
                children: sizeStepper
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "".concat((_LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().countDownButton), " ").concat(buttonStyle),
                onClick: function() {
                    return setSizeStepper(sizeStepper + 1);
                },
                disabled: sizeStepper >= count || sizeStepper === 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/stepper_increment_icon.svg",
                    alt: t("META.STEPPER_INCREMENT_ICON"),
                    width: 12,
                    height: 12
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LuggageButtonComponent);


/***/ }),

/***/ 94738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2248);
/* harmony import */ var lib_checkBreakpoint__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92122);
/* harmony import */ var _OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33030);
/* harmony import */ var _OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);






var OwnerSection = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var isDesktop = (0,lib_checkBreakpoint__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isDesktop;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ownerSection),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ownerSectionBox),
            children: [
                isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/owner_section_illustration.webp",
                    alt: t("META.OWNER_SECTION_ILLUSTRATION")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ownerSectionBoxTitle),
                    children: t("TOP.OWNER.TITLE")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: (_OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ownerSectionBoxButton),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "https://join-cloak.ecbo.io/owner".concat(locale === "zh-TW" ? "/".concat(locale) : ""),
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            children: t("TOP.OWNER.REGISTER")
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OwnerSection);


/***/ }),

/***/ 57577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LoadingComponent_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87483);
/* harmony import */ var _LoadingComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_LoadingComponent_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var LoadingComponent = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_LoadingComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loading),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_LoadingComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loadingObject),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/service_icon.webp",
                alt: "Loading"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingComponent);


/***/ }),

/***/ 21998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F$": function() { return /* binding */ PRICE_SIZE_TYPE_BAG; },
/* harmony export */   "Id": function() { return /* binding */ PRICE; },
/* harmony export */   "TD": function() { return /* binding */ PRICE_SIZE_TYPE_SUITCASE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var PRICE_SIZE_TYPE_BAG = "bag";
var PRICE_SIZE_TYPE_SUITCASE = "suitcase";
var _obj;
// 金額
var PRICE = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PRICE_SIZE_TYPE_BAG, {
    jpn: 500,
    en: 500,
    twn: 80
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PRICE_SIZE_TYPE_SUITCASE, {
    jpn: 800,
    en: 800,
    twn: 160
}), _obj);


/***/ }),

/***/ 21546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ usePlaceAutoCompletion; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/lib/axios.ts
var axios = __webpack_require__(61969);
;// CONCATENATED MODULE: ./src/features/places/services/placesAutocompleteApi.ts



var API_PLACES_AUTOCOMPLETE = "/api/web/places/autocomplete";
var fetchPlacesAutocomplete = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input, accessToken) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* ecboClient.get */.ZK.get(API_PLACES_AUTOCOMPLETE, {
                            params: {
                                input: input,
                                platform: "web"
                            },
                            headers: accessToken ? {
                                Authorization: "Token ".concat(accessToken)
                            } : undefined
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function fetchPlacesAutocomplete(input, accessToken) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/features/tracking/lib/location.ts
var lib_location = __webpack_require__(45060);
// EXTERNAL MODULE: ./src/lib/gtag.ts
var gtag = __webpack_require__(31418);
// EXTERNAL MODULE: ./src/state/ducks/locations/apis.ts
var apis = __webpack_require__(89130);
;// CONCATENATED MODULE: ./src/features/places/hooks/usePlaceAutoCompletion.ts











var usePlaceAutoCompletion = function() {
    var cookies = (0,dist.parseCookies)();
    var ref = (0,react.useState)(""), searchText = ref[0], setSearchTextState = ref[1];
    var ref1 = (0,react.useState)([]), places = ref1[0], setPlaces = ref1[1];
    var ref2 = (0,react.useState)(null), status = ref2[0], setStatus = ref2[1];
    // 入力欄への初期値の反映で実行される検索は計測しない
    var isUserInputRef = (0,react.useRef)(false);
    var setSearchText = (0,react.useCallback)(function(text) {
        isUserInputRef.current = false;
        setSearchTextState(text);
    }, []);
    var setSearchTextFromInput = (0,react.useCallback)(function(text) {
        isUserInputRef.current = true;
        setSearchTextState(text);
    }, []);
    var searchPlaces = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(text) {
            var result, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!text) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetchPlacesAutocomplete(text, cookies.jwt_token)
                        ];
                    case 2:
                        result = _state.sent();
                        setStatus(result.status);
                        if (result.status === "OK") {
                            setPlaces(result.predictions);
                        } else {
                            setPlaces([]);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setPlaces([]);
                        setStatus(null);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(text) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cookies.jwt_token
    ]);
    var debouncedSearch = (0,react.useMemo)(function() {
        return lodash_debounce_default()(function(text) {
            if (isUserInputRef.current) {
                (0,gtag/* sendGtmLocationEvent */.Tw)(gtag/* GTM_EVENT_SPACE_ADDRESS_SEARCH */.P$, {
                    search_keyword: text
                });
            }
            searchPlaces(text);
        }, 1000);
    }, [
        searchPlaces
    ]);
    var getGeocode = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(placeId) {
            var result, geometry;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,apis/* goolgeMapGetPlaceDetail */.uu)(placeId, cookies.jwt_token)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.status === "OK") {
                            geometry = result.result.geometry;
                            return [
                                2,
                                geometry.location
                            ];
                        }
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function(placeId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cookies.jwt_token
    ]);
    var selectPlace = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(place) {
            var location;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getGeocode(place.place_id)
                        ];
                    case 1:
                        location = _state.sent();
                        if (location) {
                            (0,gtag/* sendGtmLocationEvent */.Tw)(gtag/* GTM_EVENT_LOCATION_SEARCH_SELECT */.CO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,lib_location/* toAnalyticsLocation */.N)(location.lat, location.lng)), {
                                search_keyword: searchText,
                                selected_location: place.description
                            }));
                        }
                        return [
                            2,
                            location
                        ];
                }
            });
        });
        return function(place) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getGeocode,
        searchText
    ]);
    (0,react.useEffect)(function() {
        if (searchText) {
            debouncedSearch(searchText);
        } else {
            debouncedSearch.cancel();
            setPlaces([]);
            setStatus(null);
        }
        return function() {
            debouncedSearch.cancel();
        };
    }, [
        debouncedSearch,
        searchText
    ]);
    return {
        places: places,
        status: status,
        searchText: searchText,
        setSearchText: setSearchText,
        setSearchTextFromInput: setSearchTextFromInput,
        setPlaces: setPlaces,
        getGeocode: getGeocode,
        selectPlace: selectPlace
    };
};


/***/ }),

/***/ 45060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ toAnalyticsLocation; },
/* harmony export */   "W": function() { return /* binding */ getDistanceInMeters; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);

// 小数点以下3桁 ≈ 110m: 正確な位置は記録せず、エリア単位の需要分析に足る精度
var COORDS_PRECISION = 3;
var AREA_BUCKET_PRECISION = 2;
var EARTH_RADIUS_METERS = 6371000;
// アプリ（lodash の round）と同じく指数表記で桁をずらし、浮動小数点の誤差で丸め結果がずれないようにする
var round = function(value, precision) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("".concat(value).split("e"), 2), base = ref[0], tmp = ref[1], exponent = tmp === void 0 ? "0" : tmp;
    var shifted = Math.round(Number("".concat(base, "e").concat(Number(exponent) + precision)));
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("".concat(shifted).split("e"), 2), shiftedBase = ref1[0], tmp1 = ref1[1], shiftedExponent = tmp1 === void 0 ? "0" : tmp1;
    return Number("".concat(shiftedBase, "e").concat(Number(shiftedExponent) - precision));
};
var toAnalyticsLocation = function(latitude, longitude) {
    var roundedLatitude = round(latitude, COORDS_PRECISION);
    var roundedLongitude = round(longitude, COORDS_PRECISION);
    var areaLatitude = round(latitude, AREA_BUCKET_PRECISION);
    var areaLongitude = round(longitude, AREA_BUCKET_PRECISION);
    return {
        latitude: roundedLatitude,
        longitude: roundedLongitude,
        location_coordinate: "".concat(roundedLatitude.toFixed(COORDS_PRECISION), ",").concat(roundedLongitude.toFixed(COORDS_PRECISION)),
        area_bucket: "".concat(areaLatitude.toFixed(AREA_BUCKET_PRECISION), ",").concat(areaLongitude.toFixed(AREA_BUCKET_PRECISION))
    };
};
var toRadians = function(degrees) {
    return degrees * (Math.PI / 180);
};
var getDistanceInMeters = function(latitude1, longitude1, latitude2, longitude2) {
    var dLatitude = toRadians(latitude2 - latitude1);
    var dLongitude = toRadians(longitude2 - longitude1);
    var a = Math.sin(dLatitude / 2) * Math.sin(dLatitude / 2) + Math.cos(toRadians(latitude1)) * Math.cos(toRadians(latitude2)) * Math.sin(dLongitude / 2) * Math.sin(dLongitude / 2);
    return EARTH_RADIUS_METERS * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};


/***/ }),

/***/ 65294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


var KEY_PREFIX = "ecbo_scroll_el_";
// Destination URL (with locale prefix) of the most recent popstate navigation.
// null = last navigation was a link/push, not back/forward.
// Persists across component unmount/remount since it's module-level.
var pendingPopStatePath = null;
if (true) {
    // window.location is already updated to the destination when popstate fires.
    window.addEventListener("popstate", function() {
        pendingPopStatePath = window.location.pathname + window.location.search;
    });
}
// Strip locale prefix so the path matches router.asPath (which has no locale).
// Handles: /en/bookings → /bookings, /zh-TW/bookings → /bookings
var stripLocalePrefix = function(path) {
    return path.replace(/^\/[a-z]{2}(-[A-Z]{2})?(?=\/)/, "");
};
var getScrollTarget = function(el) {
    return el !== null && el !== void 0 ? el : document.body;
};
var getScrollTop = function(el) {
    return el === document.body ? el.scrollTop || document.documentElement.scrollTop : el.scrollTop;
};
/**
 * Save/restore scroll position for browser back/forward navigation only.
 * Supports both custom scroll containers (attach the returned ref) and
 * document.body (ignore the returned ref). `isReady` defers restore until
 * CSR data has loaded; retries until the element is tall enough.
 */ var useScrollPositionRestoration = function() {
    var isReady = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    // Persist scrollTop on every navigation away.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleRouteChangeStart = function() {
            var el = getScrollTarget(ref.current);
            var scrollTop = getScrollTop(el);
            if (scrollTop > 0) {
                sessionStorage.setItem("".concat(KEY_PREFIX).concat(router.asPath), String(scrollTop));
            }
        };
        var handleRouteChangeError = function() {
            pendingPopStatePath = null;
        };
        router.events.on("routeChangeStart", handleRouteChangeStart);
        router.events.on("routeChangeError", handleRouteChangeError);
        return function() {
            router.events.off("routeChangeStart", handleRouteChangeStart);
            router.events.off("routeChangeError", handleRouteChangeError);
        };
    }, [
        router
    ]);
    // Restore — only if this page was reached via back/forward AND the recorded
    // destination matches the current path. Guards against stale pendingPopStatePath
    // left over when forward-navigating to a page that does not use this hook.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isReady) return;
        var key = "".concat(KEY_PREFIX).concat(router.asPath);
        var raw = sessionStorage.getItem(key);
        if (raw === null) return;
        var isPopState = pendingPopStatePath !== null && stripLocalePrefix(pendingPopStatePath) === router.asPath;
        if (!isPopState) {
            sessionStorage.removeItem(key);
            return;
        }
        pendingPopStatePath = null;
        sessionStorage.removeItem(key);
        var targetY = Number(raw);
        var MAX_RETRIES = 6;
        var retries = 0;
        var timeoutId = null;
        var attempt = function() {
            var el = getScrollTarget(ref.current);
            el.scrollTop = targetY;
            if (Math.abs(getScrollTop(el) - targetY) < 1 || retries >= MAX_RETRIES) return;
            retries++;
            timeoutId = setTimeout(attempt, 50 * retries) // 50ms → 100ms → 150ms → ...
            ;
        };
        requestAnimationFrame(attempt);
        return function() {
            if (timeoutId !== null) clearTimeout(timeoutId);
        };
    }, [
        isReady,
        router.asPath
    ]);
    return ref;
};
/* harmony default export */ __webpack_exports__["Z"] = (useScrollPositionRestoration);


/***/ }),

/***/ 75617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ GoogleMapOptions; }
/* harmony export */ });
// use https://snazzymaps.com/
var GoogleMapOptions = [
    {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [
            {
                saturation: 36
            },
            {
                color: "#333333"
            },
            {
                lightness: 40
            }, 
        ]
    },
    {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
            {
                visibility: "on"
            },
            {
                color: "#ffffff"
            },
            {
                lightness: 16
            }, 
        ]
    },
    {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }, 
        ]
    },
    {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#fefefe"
            },
            {
                lightness: 20
            }, 
        ]
    },
    {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#fefefe"
            },
            {
                lightness: 17
            },
            {
                weight: 1.2
            }, 
        ]
    },
    {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
            {
                hue: "#f3f4f4"
            },
            {
                saturation: -84
            },
            {
                lightness: 59
            },
            {
                visibility: "on"
            }, 
        ]
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
            {
                color: "#f5f5f5"
            },
            {
                lightness: 21
            }, 
        ]
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
            {
                color: "#dedede"
            },
            {
                lightness: 21
            }, 
        ]
    },
    {
        featureType: "poi.park",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#d1ecc7"
            }, 
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 17
            }, 
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 29
            },
            {
                weight: 0.2
            }, 
        ]
    },
    {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 18
            }, 
        ]
    },
    {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 16
            }, 
        ]
    },
    {
        featureType: "transit",
        elementType: "all",
        stylers: [
            {
                visibility: "on"
            }, 
        ]
    },
    {
        featureType: "transit.line",
        elementType: "all",
        stylers: [
            {
                visibility: "on"
            }, 
        ]
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [
            {
                color: "#bddddd"
            },
            {
                lightness: 17
            }, 
        ]
    }, 
];


/***/ }),

/***/ 83579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getSpacePrice; }
/* harmony export */ });
/* harmony import */ var configs_space__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21998);
/* harmony import */ var state_ducks_space_models__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43340);


/**
 * 国コード、サイズの種類を判定して、金額を取得する
 * @param {string} country_code 国コード
 * @param {string} size_type サイズの種類
 * @returns
 */ var getSpacePrice = function() {
    var country_code = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "jpn", size_type = arguments.length > 1 ? arguments[1] : void 0;
    // 国コードの有効判定チェック
    var countryCodes = [
        "jpn",
        "twn"
    ];
    country_code = countryCodes.includes(country_code) ? country_code : "jpn";
    var price = configs_space__WEBPACK_IMPORTED_MODULE_0__/* .PRICE */ .Id[size_type][country_code];
    var currency = "";
    switch(country_code){
        case "jpn":
            currency = state_ducks_space_models__WEBPACK_IMPORTED_MODULE_1__/* .SpaceCurrency.cny */ .D4.cny;
            break;
        case "twn":
            currency = state_ducks_space_models__WEBPACK_IMPORTED_MODULE_1__/* .SpaceCurrency.twd */ .D4.twd;
            break;
        case "en":
            currency = state_ducks_space_models__WEBPACK_IMPORTED_MODULE_1__/* .SpaceCurrency.cny */ .D4.cny;
            break;
        default:
            currency = state_ducks_space_models__WEBPACK_IMPORTED_MODULE_1__/* .SpaceCurrency.cny */ .D4.cny;
            break;
    }
    return "".concat(currency).concat(price.toLocaleString());
};


/***/ }),

/***/ 5402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 13 modules
var esm = __webpack_require__(2248);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/state/ducks/locations/selectors.ts

var getLocationDetail = (0,reselect_es/* createSelector */.P1)(function(param) {
    var _locationDetail = param._locationDetail;
    return _locationDetail.data;
}, function(_locationDetail) {
    return _locationDetail.result;
});
var getLocationPopularAreas = (0,reselect_es/* createSelector */.P1)(function(param) {
    var locationPopularAreas = param.locationPopularAreas;
    return locationPopularAreas.data;
}, function(locationPopularAreas) {
    return locationPopularAreas.result;
});
//おすすめ預かり場所
var getLocationRecommendedSpaces = (0,reselect_es/* createSelector */.P1)(function(param) {
    var locationRecommendedSpaces = param.locationRecommendedSpaces;
    return locationRecommendedSpaces.data;
}, function(locationRecommendedSpacesState) {
    return locationRecommendedSpacesState.result;
});
// コインロッカー
var getLocationCoinLockers = (0,reselect_es/* createSelector */.P1)(function(param) {
    var locationCoinLockers = param.locationCoinLockers;
    return locationCoinLockers.data;
}, function(locationCoinLockersState) {
    return locationCoinLockersState.result;
});
// 駅
var getLocationStations = (0,reselect_es/* createSelector */.P1)(function(param) {
    var locationStations = param.locationStations;
    return locationStations.data;
}, function(locationStationsState) {
    return locationStationsState.result;
});
// 施設
var getLocationFacilities = (0,reselect_es/* createSelector */.P1)(function(param) {
    var locationFacilities = param.locationFacilities;
    return locationFacilities.data;
}, function(locationFacilitiesState) {
    return locationFacilitiesState.result;
});
// 旧コインロッカー
var getLocationOldCoinLockers = (0,reselect_es/* createSelector */.P1)(function(param) {
    var locationOldCoinLockers = param.locationOldCoinLockers;
    return locationOldCoinLockers;
}, function(locationOldCoinLockersState) {
    return locationOldCoinLockersState.data;
});

// EXTERNAL MODULE: ./src/lib/getAcceptLanguageByLocale.ts
var getAcceptLanguageByLocale = __webpack_require__(73657);
;// CONCATENATED MODULE: ./src/lib/getInfoByLocale.ts
/**
 * 言語の種類で該当するオブジェクトを返す
 * @param locale string 言語
 * @param data Oject 言語データ
 * @returns data['ja']
 */ function getInfoByLocale(locale, data) {
    if (data[locale]) return data[locale];
    return data["ja"];
}

// EXTERNAL MODULE: ./src/lib/meta.tsx
var meta = __webpack_require__(22923);
// EXTERNAL MODULE: ./src/hooks/tracking/useAffiliateTracking.ts
var useAffiliateTracking = __webpack_require__(64007);
// EXTERNAL MODULE: ./src/hooks/common/useScrollPositionRestoration.ts
var useScrollPositionRestoration = __webpack_require__(65294);
// EXTERNAL MODULE: ./src/lib/gtag.ts
var gtag = __webpack_require__(31418);
// EXTERNAL MODULE: ./src/configs/space.ts
var configs_space = __webpack_require__(21998);
;// CONCATENATED MODULE: ./src/features/space/lib/buildNearbySpacesParams.ts


var buildNearbySpacesParams = function(param) {
    var locationDetail = param.locationDetail, isCity = param.isCity, page = param.page, pageSize = param.pageSize, locale = param.locale, filterCondition = param.filterCondition;
    var ref;
    var base = (0,_object_spread/* default */.Z)({
        latitude: locationDetail.latitude,
        longitude: locationDetail.longitude,
        page: page,
        page_size: pageSize,
        locale: locale
    }, filterCondition ? {
        filter_condition: filterCondition
    } : {});
    if (isCity) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
            prefecture_id: locationDetail.id
        });
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
        prefecture_id: (ref = locationDetail.region) === null || ref === void 0 ? void 0 : ref.id,
        facility_id: locationDetail.id
    });
};

;// CONCATENATED MODULE: ./src/features/space/lib/mapNearbySpaceToRecommendedSpace.ts



var BAG_SIZE = "small";
var SUITCASE_SIZE = "large";
var formatPrice = function(price) {
    return "\xa5".concat(price.toLocaleString());
};
var getCapacityQuantity = function(capacity, size) {
    var ref;
    var ref1;
    return (ref1 = (ref = capacity === null || capacity === void 0 ? void 0 : capacity.find(function(item) {
        return item.size === size;
    })) === null || ref === void 0 ? void 0 : ref.quantity) !== null && ref1 !== void 0 ? ref1 : 0;
};
var getPriceLabel = function(prices, size) {
    var ref;
    var price = (ref = prices === null || prices === void 0 ? void 0 : prices.find(function(item) {
        return item.size === size;
    })) === null || ref === void 0 ? void 0 : ref.price;
    return price !== undefined ? formatPrice(price) : "";
};
var toSpacePhotos = function(space) {
    var ref;
    var ref1;
    var photos = (ref1 = (ref = space.space_photos) === null || ref === void 0 ? void 0 : ref.filter(function(photo) {
        return !!photo.url;
    }).map(function(photo) {
        return {
            url: photo.url,
            photo_description: photo.photo_description
        };
    })) !== null && ref1 !== void 0 ? ref1 : [];
    if (photos.length > 0) {
        return photos;
    }
    if (space.main_image_url) {
        return [
            {
                url: space.main_image_url,
                photo_description: ""
            }
        ];
    }
    return [];
};
var toBookings = function(weeklyAvailabilities) {
    var ref;
    return (ref = weeklyAvailabilities === null || weeklyAvailabilities === void 0 ? void 0 : weeklyAvailabilities.map(function(availability) {
        var date = dayjs_min_default()(availability.date);
        return {
            date: availability.date,
            day_of_week: availability.day_of_week,
            day_of_week_label: date.format("ddd"),
            ratio: availability.ratio,
            isHoliday: availability.is_holiday,
            capacity: availability.capacity
        };
    })) !== null && ref !== void 0 ? ref : [];
};
var toReviews = function(space) {
    var topReviews = space.top_reviews, total_review_count = space.total_review_count, average_review_rating = space.average_review_rating;
    if (!topReviews || topReviews.length === 0) {
        return {
            comment: "",
            user_name: "",
            total_review_count: total_review_count !== null && total_review_count !== void 0 ? total_review_count : 0,
            average_review: average_review_rating !== null && average_review_rating !== void 0 ? average_review_rating : 0
        };
    }
    var firstReview = topReviews[0];
    var averageReview = average_review_rating !== null && average_review_rating !== void 0 ? average_review_rating : topReviews.reduce(function(sum, review) {
        return sum + review.rating;
    }, 0) / topReviews.length;
    return {
        comment: firstReview.comment,
        user_name: "".concat(firstReview.review_user.last_name).concat(firstReview.review_user.first_name),
        total_review_count: total_review_count !== null && total_review_count !== void 0 ? total_review_count : 0,
        average_review: averageReview
    };
};
var toTodayBusinessHours = function(workingHours) {
    if (!workingHours) {
        return {
            open_at_today: "",
            close_at_today: "",
            available_24_hour: false
        };
    }
    var _open_at, _close_at;
    return {
        open_at_today: (_open_at = workingHours.open_at) !== null && _open_at !== void 0 ? _open_at : "",
        close_at_today: (_close_at = workingHours.close_at) !== null && _close_at !== void 0 ? _close_at : "",
        available_24_hour: workingHours.is_24_hours
    };
};
var mapNearbySpaceToRecommendedSpace = function(space) {
    var ref;
    var spacePhotos = toSpacePhotos(space);
    var nearestStation = (ref = space.nearby_stations) === null || ref === void 0 ? void 0 : ref[0];
    var todayBusinessHours = toTodayBusinessHours(space.working_hours);
    var ref1, ref2, ref3;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: space.space_id,
        encrypted_id: space.encrypted_id,
        name: space.name,
        space_photo: spacePhotos[0],
        space_photos: spacePhotos,
        bag_size: getCapacityQuantity(space.capacity, BAG_SIZE),
        suitcase_size: getCapacityQuantity(space.capacity, SUITCASE_SIZE)
    }, todayBusinessHours), {
        open_at_mon: "",
        close_at_mon: "",
        open_at_tue: "",
        close_at_tue: "",
        open_at_wed: "",
        close_at_wed: "",
        open_at_thu: "",
        close_at_thu: "",
        open_at_fri: "",
        close_at_fri: "",
        open_at_sat: "",
        close_at_sat: "",
        open_at_sun: "",
        close_at_sun: "",
        can_book_on_the_day: false,
        can_book_multiple_days: false,
        station_1_name: (ref1 = nearestStation === null || nearestStation === void 0 ? void 0 : nearestStation.station_name) !== null && ref1 !== void 0 ? ref1 : "",
        station_1_en_name: (ref2 = nearestStation === null || nearestStation === void 0 ? void 0 : nearestStation.station_name) !== null && ref2 !== void 0 ? ref2 : "",
        distance_from_station_1: (ref3 = nearestStation === null || nearestStation === void 0 ? void 0 : nearestStation.distance) !== null && ref3 !== void 0 ? ref3 : 0,
        zip_code: "",
        address: "",
        latitude: 0,
        longitude: 0,
        google_place_url: "",
        is_available_on_sun: 0,
        is_available_on_mon: 0,
        is_available_on_tue: 0,
        is_available_on_wed: 0,
        is_available_on_thu: 0,
        is_available_on_fri: 0,
        is_available_on_sat: 0,
        bookings: toBookings(space.weekly_availabilities),
        prices: {
            bag_size: getPriceLabel(space.prices, BAG_SIZE),
            suitecase_size: getPriceLabel(space.prices, SUITCASE_SIZE)
        },
        reviews: toReviews(space)
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./src/lib/axios.ts
var axios = __webpack_require__(61969);
;// CONCATENATED MODULE: ./src/features/space/services/nearbySpacesApi.ts




var API_NEARBY_SPACES = "/api/web/spaces/nearby";
var fetchNearbySpaces = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
        var response, error, ref, status;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios/* ecboClient.get */.ZK.get(API_NEARBY_SPACES, {
                            params: (0,_object_spread/* default */.Z)({
                                latitude: params.latitude,
                                longitude: params.longitude,
                                page: params.page,
                                page_size: params.page_size
                            }, params.prefecture_id !== undefined ? {
                                prefecture_id: params.prefecture_id
                            } : {}, params.facility_id !== undefined ? {
                                facility_id: params.facility_id
                            } : {}, params.filter_condition ? {
                                filter_condition: params.filter_condition
                            } : {}),
                            headers: {
                                "Accept-Language": (0,axios/* getHeaderLocale */.hi)(params.locale)
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            isOk: true,
                            data: response.data
                        }
                    ];
                case 2:
                    error = _state.sent();
                    status = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status;
                    return [
                        2,
                        {
                            isOk: false,
                            data: null,
                            isNotFound: status === 404
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchNearbySpaces(params) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/space/hooks/useNearbySpaces.ts






var useNearbySpaces = function() {
    var ref = (0,react.useState)([]), spaces = ref[0], setSpaces = ref[1];
    var ref1 = (0,react.useState)(0), totalCount = ref1[0], setTotalCount = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(false), isError = ref3[0], setIsError = ref3[1];
    var loadNearbySpaces = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
            var result, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setIsError(false);
                        setSpaces([]);
                        setTotalCount(0);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            fetchNearbySpaces(params)
                        ];
                    case 2:
                        result = _state.sent();
                        if (result.isOk) {
                            setSpaces(result.data.spaces);
                            setTotalCount(result.data.total_count);
                        } else {
                            setSpaces([]);
                            setTotalCount(0);
                            setIsError(true);
                            esm_exports/* captureException */.Tb(new Error("fetchNearbySpaces returned isOk: false"), {
                                tags: {
                                    hook: "useNearbySpaces"
                                },
                                extra: {
                                    params: params,
                                    isNotFound: result.isNotFound
                                }
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setSpaces([]);
                        setTotalCount(0);
                        setIsError(true);
                        esm_exports/* captureException */.Tb((0,_instanceof/* default */.Z)(error, Error) ? error : new Error(String(error)), {
                            tags: {
                                hook: "useNearbySpaces"
                            },
                            extra: {
                                params: params
                            }
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        spaces: spaces,
        totalCount: totalCount,
        isLoading: isLoading,
        isError: isError,
        loadNearbySpaces: loadNearbySpaces
    };
};

// EXTERNAL MODULE: ./src/state/ducks/locations/actions.ts
var actions = __webpack_require__(83708);
// EXTERNAL MODULE: ./src/features/prefecture/hooks/usePrefectures.ts + 1 modules
var usePrefectures = __webpack_require__(55213);
// EXTERNAL MODULE: ./src/features/prefecture/constants.ts
var constants = __webpack_require__(59658);
;// CONCATENATED MODULE: ./src/features/prefecture/lib/findPrefectureIdBySlug.ts
var findPrefectureIdBySlug = function(prefectureAreas, slug) {
    if (!(prefectureAreas === null || prefectureAreas === void 0 ? void 0 : prefectureAreas.length) || !slug) return undefined;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = prefectureAreas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var area = _step.value;
            var prefecture = area.prefectures.find(function(item) {
                return item.slug === slug;
            });
            if (prefecture) return prefecture.id;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return undefined;
};

// EXTERNAL MODULE: ./src/state/ducks/space/apis.ts
var apis = __webpack_require__(17580);
;// CONCATENATED MODULE: ./src/hooks/spaces/useAreaLockers.ts




var useAreaLockers = function() {
    var ref = (0,react.useState)([]), lockers = ref[0], setLockers = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setLoading = ref1[1];
    var handleGetAreaLockers = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
            var result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            (0,apis/* getAreaLockers */.H4)(params)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.isOk) {
                            setLockers(result.data);
                        }
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        lockers: lockers,
        isLoading: isLoading,
        getAreaLockers: handleGetAreaLockers
    };
};

// EXTERNAL MODULE: ./src/features/facility/hooks/useStations.ts
var useStations = __webpack_require__(56313);
// EXTERNAL MODULE: ./src/features/facility/hooks/useFacilities.ts
var useFacilities = __webpack_require__(57618);
;// CONCATENATED MODULE: ./src/features/coin-locker/services/fetchLegacyCoinLockersApi.ts



var API_LEGACY_COIN_LOCKERS = "/api/web/coin_lockers";
var fetchLegacyCoinLockersApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* ecboClient.get */.ZK.get(API_LEGACY_COIN_LOCKERS, {
                            params: {
                                latitude: params.latitude,
                                longitude: params.longitude
                            },
                            headers: {
                                "Accept-Language": (0,axios/* getHeaderLocale */.hi)(params.locale)
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function fetchLegacyCoinLockersApi(params) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/coin-locker/hooks/useLegacyCoinLockers.ts









var useLegacyCoinLockers = function() {
    var i18n = (0,esm/* useTranslation */.$G)().i18n;
    var ref = (0,react.useState)([]), legacyCoinLockers = ref[0], setLegacyCoinLockers = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setLoading = ref1[1];
    var fetchLegacyCoinLockers = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
            var data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            fetchLegacyCoinLockersApi((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                locale: i18n.language
                            }))
                        ];
                    case 2:
                        data = _state.sent();
                        setLegacyCoinLockers(data.coin_lockers);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setLegacyCoinLockers([]);
                        esm_exports/* captureException */.Tb((0,_instanceof/* default */.Z)(error, Error) ? error : new Error(String(error)), {
                            tags: {
                                hook: "useLegacyCoinLockers"
                            },
                            extra: (0,_object_spread/* default */.Z)({
                                locale: i18n.language
                            }, params)
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(), [
        i18n.language
    ]);
    return {
        legacyCoinLockers: legacyCoinLockers,
        isLoading: isLoading,
        fetchLegacyCoinLockers: fetchLegacyCoinLockers
    };
};

// EXTERNAL MODULE: ./src/components/loadings/LoadingComponent.tsx
var LoadingComponent = __webpack_require__(57577);
// EXTERNAL MODULE: ./src/lib/getSpacePrice.ts
var getSpacePrice = __webpack_require__(83579);
// EXTERNAL MODULE: ./src/components/cards/PlanCard.module.scss
var PlanCard_module = __webpack_require__(18188);
var PlanCard_module_default = /*#__PURE__*/__webpack_require__.n(PlanCard_module);
;// CONCATENATED MODULE: ./src/components/cards/PlanCard.tsx


// hooks


function PlanCard(param) {
    var title = param.title, countryCode = param.countryCode, iconImage = param.iconImage, description = param.description, sizeType = param.sizeType, price = param.price;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PlanCard_module_default()).planCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (PlanCard_module_default()).planCardImage,
                src: iconImage,
                alt: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                className: (PlanCard_module_default()).planCardInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                        className: (PlanCard_module_default()).planCardInfoTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                        className: (PlanCard_module_default()).planCardInfoPrice,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                className: (PlanCard_module_default()).planCardInfoPriceAmount,
                                children: price ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: price
                                }) : (0,getSpacePrice/* getSpacePrice */.Q)(countryCode, sizeType)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                className: (PlanCard_module_default()).planCardInfoPriceDay,
                                children: [
                                    "/",
                                    t("AREAS.CITY.SLUG.PLAN_PRICE_DAY")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                        className: (PlanCard_module_default()).planCardInfoDescription,
                        children: description
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/commons/layouts/Layout.tsx + 4 modules
var Layout = __webpack_require__(58909);
// EXTERNAL MODULE: ./src/components/domains/top/LocationSection.tsx
var LocationSection = __webpack_require__(63995);
// EXTERNAL MODULE: ./src/components/domains/top/OwnerSection.tsx
var OwnerSection = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/components/commons/layouts/BreadcrumbLayout.tsx + 1 modules
var BreadcrumbLayout = __webpack_require__(75340);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/lib/addLocalePrefix.ts
var addLocalePrefix = __webpack_require__(57467);
;// CONCATENATED MODULE: ./src/features/facility/services/facilityRecommendationsApi.ts



var API_FACILITY_RECOMMENDATIONS = "/api/web/facilities/recommendations";
var fetchFacilityRecommendations = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* ecboClient.get */.ZK.get(API_FACILITY_RECOMMENDATIONS, {
                            params: {
                                latitude: params.latitude,
                                longitude: params.longitude,
                                type: params.type,
                                prefecture_id: params.prefecture_id
                            },
                            headers: {
                                "Accept-Language": (0,axios/* getHeaderLocale */.hi)(params.locale)
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function fetchFacilityRecommendations(params) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/facility/hooks/useFacilityRecommendations.ts









var useFacilityRecommendations = function() {
    var i18n = (0,esm/* useTranslation */.$G)().i18n;
    var ref = (0,react.useState)([]), facilities = ref[0], setFacilities = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isError = ref2[0], setIsError = ref2[1];
    var fetchRecommendations = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
            var data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setIsError(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            fetchFacilityRecommendations((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                locale: i18n.language
                            }))
                        ];
                    case 2:
                        data = _state.sent();
                        setFacilities(data);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setIsError(true);
                        setFacilities([]);
                        esm_exports/* captureException */.Tb((0,_instanceof/* default */.Z)(error, Error) ? error : new Error(String(error)), {
                            tags: {
                                hook: "useFacilityRecommendations"
                            },
                            extra: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                locale: i18n.language
                            })
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(), [
        i18n.language
    ]);
    return {
        facilities: facilities,
        isLoading: isLoading,
        isError: isError,
        fetchRecommendations: fetchRecommendations
    };
};

// EXTERNAL MODULE: ./src/components/titles/SectionBottomBorderTitle.module.scss
var SectionBottomBorderTitle_module = __webpack_require__(42069);
var SectionBottomBorderTitle_module_default = /*#__PURE__*/__webpack_require__.n(SectionBottomBorderTitle_module);
;// CONCATENATED MODULE: ./src/components/titles/SectionBottomBorderTitle.tsx


var SectionBottomBorderTitle = function(param) {
    var text = param.text, subTextElement = param.subTextElement;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
        className: (SectionBottomBorderTitle_module_default()).title,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                className: (SectionBottomBorderTitle_module_default()).titleText,
                children: text
            }),
            subTextElement && subTextElement
        ]
    });
};
/* harmony default export */ var titles_SectionBottomBorderTitle = (SectionBottomBorderTitle);

// EXTERNAL MODULE: ./src/components/cards/AreaCard.module.scss
var AreaCard_module = __webpack_require__(23398);
var AreaCard_module_default = /*#__PURE__*/__webpack_require__.n(AreaCard_module);
;// CONCATENATED MODULE: ./src/components/cards/AreaCard.tsx


var AreaCard = function(param) {
    var name = param.name, imageUrl = param.imageUrl, href = param.href;
    imageUrl = imageUrl != null && imageUrl !== "" ? imageUrl : "/location_popular_area_default.webp";
    var style = {
        backgroundImage: "url(".concat(imageUrl, ")")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: href,
        className: (AreaCard_module_default()).link,
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (AreaCard_module_default()).linkText,
            children: name
        })
    });
};
/* harmony default export */ var cards_AreaCard = (AreaCard);

// EXTERNAL MODULE: ./src/components/domains/facility/FacilityRecommendationsSection/FacilityCardList.module.scss
var FacilityCardList_module = __webpack_require__(7598);
var FacilityCardList_module_default = /*#__PURE__*/__webpack_require__.n(FacilityCardList_module);
;// CONCATENATED MODULE: ./src/components/domains/facility/FacilityRecommendationsSection/FacilityCardList.tsx



var FacilityCardList = function(param) {
    var facilities = param.facilities, countrySlug = param.countrySlug, citySlug = param.citySlug, localePath = param.localePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (FacilityCardList_module_default()).list,
        children: facilities.map(function(facility) {
            var href = "/".concat(localePath, "/").concat(countrySlug, "/city/").concat(citySlug, "/").concat(facility.id);
            var _image_url;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (FacilityCardList_module_default()).listItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_AreaCard, {
                    name: facility.name,
                    href: href,
                    imageUrl: (_image_url = facility.image_url) !== null && _image_url !== void 0 ? _image_url : undefined
                })
            }, facility.id);
        })
    });
};
/* harmony default export */ var FacilityRecommendationsSection_FacilityCardList = (FacilityCardList);

// EXTERNAL MODULE: ./src/components/domains/facility/FacilityRecommendationsSection/FacilityRecommendationsSection.module.scss
var FacilityRecommendationsSection_module = __webpack_require__(42427);
var FacilityRecommendationsSection_module_default = /*#__PURE__*/__webpack_require__.n(FacilityRecommendationsSection_module);
;// CONCATENATED MODULE: ./src/components/domains/facility/FacilityRecommendationsSection/index.tsx









var FacilityRecommendationsSection = function(param) {
    var latitude = param.latitude, longitude = param.longitude, type = param.type, prefectureId = param.prefectureId, locationName = param.locationName, countrySlug = param.countrySlug, citySlug = param.citySlug, localePath = param.localePath, locale = param.locale;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = useFacilityRecommendations(), facilities = ref.facilities, fetchRecommendations = ref.fetchRecommendations;
    (0,react.useEffect)(function() {
        fetchRecommendations({
            latitude: latitude,
            longitude: longitude,
            type: type,
            prefecture_id: prefectureId
        });
    }, [
        latitude,
        longitude,
        type,
        prefectureId,
        fetchRecommendations
    ]);
    if (facilities.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (FacilityRecommendationsSection_module_default()).section,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FacilityRecommendationsSection_module_default()).sectionContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(titles_SectionBottomBorderTitle, {
                    text: t("AREAS.CITY.SLUG.POPULAR_TITLE", {
                        location: locationName
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FacilityRecommendationsSection_FacilityCardList, {
                    facilities: facilities,
                    countrySlug: countrySlug,
                    citySlug: citySlug,
                    localePath: localePath
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (FacilityRecommendationsSection_module_default()).sectionOther,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: {
                            pathname: (0,addLocalePrefix/* addLocalePrefix */.Le)("/locations", locale),
                            query: {
                                name: locationName,
                                lat: latitude,
                                lon: longitude
                            }
                        },
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (FacilityRecommendationsSection_module_default()).sectionOtherLink,
                            children: t("AREAS.CITY.SLUG.RECOMMENDED_CHECK_AREA_LIST")
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var facility_FacilityRecommendationsSection = (FacilityRecommendationsSection);

// EXTERNAL MODULE: ./src/components/cards/RecommendedCoinLockerCardList.module.scss
var RecommendedCoinLockerCardList_module = __webpack_require__(97019);
var RecommendedCoinLockerCardList_module_default = /*#__PURE__*/__webpack_require__.n(RecommendedCoinLockerCardList_module);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(86529);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.mjs
var fa = __webpack_require__(52091);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/features/space/lib/buildSpaceDetailHref.ts
var buildSpaceDetailHref = __webpack_require__(18268);
// EXTERNAL MODULE: ./src/features/space/lib/resolveCanonicalSpaceUuid.ts
var resolveCanonicalSpaceUuid = __webpack_require__(76443);
;// CONCATENATED MODULE: ./src/utils/helpers.ts
var getSpaceAvailabilities = function(availability) {
    var iconImage = {
        src: "/empty_status_circle_03.svg",
        alt: "◯"
    };
    if (availability.is_holiday) {
        iconImage.src = "/empty_status_cross.svg";
        iconImage.alt = "x";
    } else {
        if (availability.ratio > 0 && availability.ratio < 100) {
            iconImage.src = "/empty_status_triangle.svg";
            iconImage.alt = "△";
        }
        if (availability.ratio === 0) {
            iconImage.src = "/empty_status_circle_03.svg";
            iconImage.alt = "◯";
        }
        if (availability.ratio === 100) {
            iconImage.src = "/empty_status_cross.svg";
            iconImage.alt = "x";
        }
    }
    var _date = new Date(availability.date);
    var month = _date.getMonth() + 1;
    var day = _date.getDate();
    var date = "".concat(month, "/").concat(day);
    return {
        date: date,
        iconImage: iconImage
    };
};
var scrollToTop = function() {
    var pos = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    console.log("pos", pos);
    if (pos > 0) {
        document.querySelector("body").scrollTo(0, 0);
    }
};

// EXTERNAL MODULE: ./src/components/cards/CoinLockerCard/styles.module.css
var styles_module = __webpack_require__(55568);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/cards/CoinLockerCard/index.tsx












var carouselResponsive = {
    desktop: {
        breakpoint: {
            max: 3000,
            min: 992
        },
        items: 1
    },
    tablet: {
        breakpoint: {
            max: 991,
            min: 576
        },
        items: 1
    },
    mobile: {
        breakpoint: {
            max: 575,
            min: 0
        },
        items: 1
    }
};
var CoinLockerCard = function(param) {
    var locker = param.locker;
    var ref, ref1;
    var t = (0,esm/* useTranslation */.$G)().t;
    var locale = (0,next_router.useRouter)().locale;
    var _encrypted_id;
    var legacyId = (_encrypted_id = locker.encrypted_id) !== null && _encrypted_id !== void 0 ? _encrypted_id : locker.space_id;
    var ref2;
    var spaceDetailHref = (0,react.useMemo)(function() {
        return (ref2 = (0,buildSpaceDetailHref/* buildSpaceDetailHref */.d)({
            locale: locale,
            spaceType: locker.space_type,
            spaceUuid: (0,resolveCanonicalSpaceUuid/* resolveCanonicalSpaceUuid */.w)(locker.space_id, locker.encrypted_id),
            encryptedId: legacyId
        })) !== null && ref2 !== void 0 ? ref2 : "#";
    }, [
        legacyId,
        locale,
        locker.encrypted_id,
        locker.space_id,
        locker.space_type
    ]);
    var availabilities = (0,react.useMemo)(function() {
        if (locker.space_type === "pudo") {
            var today = moment_default()();
            var array = Array.apply(null, {
                length: 7
            }).map(function(_, index) {
                var date = today.clone().add(index, "days").format("YYYY-MM-DD");
                var dayOfWeek = today.clone().add(index, "days").get("day");
                var dayOfWeekLabel = today.clone().add(index, "days").format("ddd");
                var ratio = 10;
                var isHoliday = false;
                return {
                    date: date,
                    day_of_week: dayOfWeek,
                    day_of_week_label: dayOfWeekLabel,
                    ratio: ratio,
                    is_holiday: isHoliday
                };
            });
            return array;
        }
        return locker.availabilities;
    }, [
        locker.availabilities,
        locker.space_type
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).dataContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).carouselContainer,
                        children: locker.space_photos.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                            ssr: true,
                            responsive: carouselResponsive,
                            infinite: true,
                            swipeable: false,
                            arrows: true,
                            customLeftArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (styles_module_default()).arrowButtonLeft,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaChevronLeft */.bUI, {
                                    size: 12,
                                    color: "gray"
                                })
                            }),
                            customRightArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (styles_module_default()).arrowButtonRight,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaChevronRight */.Dli, {
                                    size: 12,
                                    color: "gray"
                                })
                            }),
                            children: locker.space_photos.map(function(photo, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).photoContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: photo.url || "/location_popular_area_default.webp",
                                        alt: photo.photo_description
                                    })
                                }, index);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).photoContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/location_popular_area_default.webp",
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).infoContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (styles_module_default()).spaceName,
                                children: locker.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).row,
                                children: [
                                    !!locker.nearby_stations.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default()).nearbyStationContainer,
                                            children: locker.nearby_stations.map(function(station, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (styles_module_default()).distanceFromStation,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/map_pin_icon_gray.svg",
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("COMMON.HOW_MANY_DISTANCE_WALK_FROM_THE_STATION", {
                                                                stationName: station.station_name,
                                                                distance: station.distance || 0
                                                            })
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (styles_module_default()).businessHours,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/business_hours_icon_gray.svg",
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "".concat(t("COMMON.TODAY_BUSINESS_TIME"), " ").concat((locker === null || locker === void 0 ? void 0 : (ref = locker.working_hours) === null || ref === void 0 ? void 0 : ref.open_at) || "", "〜").concat((locker === null || locker === void 0 ? void 0 : (ref1 = locker.working_hours) === null || ref1 === void 0 ? void 0 : ref1.close_at) || "")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            !!locker.capacity.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).capacityContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t("COMMON.CAN_STORE_LUGGAGE_COUNT")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).row,
                                        children: locker.capacity.map(function(capacity, index) {
                                            var size = capacity.size, quantity = capacity.quantity;
                                            var label = "";
                                            if (size === "large") {
                                                label = t("LOCKER.LABEL.LARGE_SIZE");
                                            } else if (size === "small") {
                                                label = t("LOCKER.LABEL.SMALL_SIZE");
                                            } else if (size === "medium") {
                                                label = t("LOCKER.LABEL.MEDIUM_SIZE");
                                            }
                                            if (!label) return null;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (styles_module_default()).spaceCapacity,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/locker_large.svg",
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "".concat(label, " ").concat(quantity)
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).availabilityContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).availabilityTitle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("COMMON.AVAILABILITY_TIME")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).availabilityList,
                        children: availabilities.map(function(availabity, index) {
                            var day_of_week = availabity.day_of_week;
                            var availableData = getSpaceAvailabilities(availabity);
                            var holidayClasses = "";
                            if (day_of_week === 6) {
                                holidayClasses = (styles_module_default()).saturday;
                            } else if (day_of_week === 0) {
                                holidayClasses = (styles_module_default()).sunday;
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((styles_module_default()).availability, " ").concat(holidayClasses),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: availableData.date
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: availableData.iconImage.src,
                                        alt: availableData.iconImage.alt
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).buttonContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: spaceDetailHref,
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (styles_module_default()).reserveButtonLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).reserveButton,
                            children: t("COMMON.COIN_LOCKER.RESERVE")
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/cards/RecommendedCoinLockerCard.module.scss
var RecommendedCoinLockerCard_module = __webpack_require__(90219);
var RecommendedCoinLockerCard_module_default = /*#__PURE__*/__webpack_require__.n(RecommendedCoinLockerCard_module);
;// CONCATENATED MODULE: ./src/components/cards/RecommendedCoinLockerCardOld.tsx





var RecommendedCoinLockerCardOld = function(param) {
    var coinLocker = param.coinLocker;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,esm/* useTranslation */.$G)().t;
    var lockerPlaceUrl = coinLocker.locker_place_url;
    var carouselResponsive = {
        desktop: {
            breakpoint: {
                max: 3000,
                min: 992
            },
            items: 1
        },
        tablet: {
            breakpoint: {
                max: 991,
                min: 576
            },
            items: 1
        },
        mobile: {
            breakpoint: {
                max: 575,
                min: 0
            },
            items: 1
        }
    };
    var wrapWithLink = function(children, className, options) {
        if (!lockerPlaceUrl) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: className,
                children: children
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: lockerPlaceUrl,
            legacyBehavior: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: className,
                target: options === null || options === void 0 ? void 0 : options.target,
                children: children
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (RecommendedCoinLockerCard_module_default()).coinLockerCard,
        children: [
            coinLocker.locker_photos.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPhotoSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                    ssr: true,
                    responsive: carouselResponsive,
                    infinite: true,
                    swipeable: false,
                    arrows: true,
                    className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPhotoList,
                    customLeftArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "".concat((RecommendedCoinLockerCard_module_default()).coinLockerCardPhotoListArrow, " ").concat((RecommendedCoinLockerCard_module_default()).coinLockerCardPhotoListArrowLeft)
                    }),
                    customRightArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "".concat((RecommendedCoinLockerCard_module_default()).coinLockerCardPhotoListArrow, " ").concat((RecommendedCoinLockerCard_module_default()).coinLockerCardPhotoListArrowRight)
                    }),
                    children: coinLocker.locker_photos.map(function(photo, index) {
                        var _url;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPhotoListItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPhotoImage,
                                src: (_url = photo.url) !== null && _url !== void 0 ? _url : "/location_popular_area_default.webp",
                                alt: coinLocker.name
                            })
                        }, index);
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPhotoSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPhotoListItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPhotoImage,
                        src: "/location_popular_area_default.webp",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendedCoinLockerCard_module_default()).coinLockerCardContent,
                children: wrapWithLink(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: (RecommendedCoinLockerCard_module_default()).coinLockerCardTitle,
                            children: coinLocker.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (RecommendedCoinLockerCard_module_default()).coinLockerCardDistanceTime,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (RecommendedCoinLockerCard_module_default()).coinLockerCardDistanceTimeText,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (RecommendedCoinLockerCard_module_default()).coinLockerCardDistanceTimeImage,
                                            src: "/map_pin_icon_gray.svg",
                                            alt: ""
                                        }),
                                        t("COMMON.HOW_MANY_MINUTES_WALK_FROM_THE_STATION", {
                                            stationName: coinLocker.nearest_station,
                                            minutes: coinLocker.walking_time
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (RecommendedCoinLockerCard_module_default()).coinLockerCardDistanceTimeText,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (RecommendedCoinLockerCard_module_default()).coinLockerCardDistanceTimeImage,
                                            src: "/business_hours_icon_gray.svg",
                                            alt: ""
                                        }),
                                        t("COMMON.TODAY_BUSINESS_TIME"),
                                        " : ",
                                        coinLocker.open_at_today,
                                        "〜",
                                        coinLocker.close_at_today
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RecommendedCoinLockerCard_module_default()).coinLockerCardNote,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (RecommendedCoinLockerCard_module_default()).coinLockerCardNoteComment,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (RecommendedCoinLockerCard_module_default()).coinLockerCardNoteCommentText,
                                    children: coinLocker.extra_info
                                })
                            })
                        })
                    ]
                }), (RecommendedCoinLockerCard_module_default()).coinLockerCardContentLink)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPriceSize,
                children: wrapWithLink(/*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                    className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPriceSizeBox,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                            className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPriceSizeTitle,
                            children: t("COMMON.CAN_STORE_LUGGAGE_COUNT")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                            className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPriceSizeDescription,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPriceSizeNumberPrice,
                                children: [
                                    ((ref = coinLocker.storage) === null || ref === void 0 ? void 0 : ref.large_locker_storage) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPriceSizeNumberPriceItem,
                                        children: [
                                            t("COMMON.COIN_LOCKER.LARGE"),
                                            ":",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    coinLocker.storage.large_locker_storage,
                                                    " /",
                                                    " ",
                                                    (ref1 = coinLocker.price) === null || ref1 === void 0 ? void 0 : ref1.large_locker_price
                                                ]
                                            })
                                        ]
                                    }),
                                    ((ref2 = coinLocker.storage) === null || ref2 === void 0 ? void 0 : ref2.middle_locker_storage) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPriceSizeNumberPriceItem,
                                        children: [
                                            t("COMMON.COIN_LOCKER.MEDIUM"),
                                            ":",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    coinLocker.storage.middle_locker_storage,
                                                    " /",
                                                    " ",
                                                    (ref3 = coinLocker.price) === null || ref3 === void 0 ? void 0 : ref3.middle_locker_price
                                                ]
                                            })
                                        ]
                                    }),
                                    ((ref4 = coinLocker.storage) === null || ref4 === void 0 ? void 0 : ref4.small_locker_storage) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPriceSizeNumberPriceItem,
                                        children: [
                                            t("COMMON.COIN_LOCKER.SMALL"),
                                            ":",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    coinLocker.storage.small_locker_storage,
                                                    " /",
                                                    " ",
                                                    (ref5 = coinLocker.price) === null || ref5 === void 0 ? void 0 : ref5.small_locker_price
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }), (RecommendedCoinLockerCard_module_default()).coinLockerCardPriceSizeLink)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPayment,
                children: wrapWithLink(/*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                    className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPaymentBox,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                            className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPaymentTitle,
                            children: t("COMMON.METHOD_OF_PAYMENT")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                            className: (RecommendedCoinLockerCard_module_default()).coinLockerCardPaymentDescription,
                            children: coinLocker.payment
                        })
                    ]
                }), (RecommendedCoinLockerCard_module_default()).coinLockerCardPaymentLink, {
                    target: "_blank"
                })
            }),
            lockerPlaceUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (RecommendedCoinLockerCard_module_default()).coinLockerCardReserve,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: lockerPlaceUrl,
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (RecommendedCoinLockerCard_module_default()).coinLockerCardReserveButtonLink,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (RecommendedCoinLockerCard_module_default()).coinLockerCardReserveButtonOld,
                            children: t("COMMON.COIN_LOCKER.VIEW_LOCATION_THIS")
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var cards_RecommendedCoinLockerCardOld = (RecommendedCoinLockerCardOld);

// EXTERNAL MODULE: ./src/components/ads/AdBanner/styles.module.css
var AdBanner_styles_module = __webpack_require__(70405);
var AdBanner_styles_module_default = /*#__PURE__*/__webpack_require__.n(AdBanner_styles_module);
// EXTERNAL MODULE: ./src/lib/checkBreakpoint.ts
var checkBreakpoint = __webpack_require__(92122);
;// CONCATENATED MODULE: ./src/components/ads/AdBanner/index.tsx




var AdBanner = function(param) {
    var bannerUrl = param.bannerUrl, bannerImage = param.bannerImage;
    var isMobile = (0,checkBreakpoint/* default */.Z)().isMobile;
    var href = isMobile ? bannerUrl.sp : bannerUrl.pc;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: (AdBanner_styles_module_default()).container,
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
            className: (AdBanner_styles_module_default()).picture,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    media: "(max-width: 575px)",
                    srcSet: bannerImage.sp
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (AdBanner_styles_module_default()).bannerImage,
                    src: bannerImage.pc,
                    alt: "ads banner"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/constants/ads.ts
/** Shared area-page campaign config (NHK). Update URLs/images in one place when the campaign changes. */ var NHK_AREA_PAGE_BANNER_CONFIG = {
    bannerUrl: {
        pc: "https://www3.nhk.or.jp/nhkworld/en/live_tv/?cid=wohk-Live-link_site_keikyu-ecbo-pc-202604-003",
        sp: "https://www3.nhk.or.jp/nhkworld/en/live_tv/?cid=wohk-Live-link_site_keikyu-ecbo-pc-202604-004"
    },
    bannerImage: {
        pc: "/ads/nhk_pc.jpg",
        sp: "/ads/nhk_sp.jpg"
    }
};

;// CONCATENATED MODULE: ./src/components/cards/RecommendedCoinLockerCardList.tsx




//component




var RecommendedCoinLockerCardList = function(param) {
    var lockers = param.lockers, oldList = param.oldList, locale = param.locale;
    var t = (0,esm/* useTranslation */.$G)().t;
    var showAdLocale = locale === "en" || locale === "zh_tw";
    var hasLockers = lockers.length > 0 || oldList.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: hasLockers ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                lockers.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((RecommendedCoinLockerCardList_module_default()).container, " ").concat(oldList.length > 0 ? (RecommendedCoinLockerCardList_module_default()).listWithGap : ""),
                    children: lockers.map(function(locker, index) {
                        var showAdAfterSecondNew = lockers.length >= 2 && index === 1;
                        var showAdEndOnlyNewList = lockers.length === 1 && oldList.length === 0 && index === 0;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinLockerCard, {
                                    locker: locker
                                }),
                                showAdLocale && (showAdAfterSecondNew || showAdEndOnlyNewList) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdBanner, (0,_object_spread/* default */.Z)({}, NHK_AREA_PAGE_BANNER_CONFIG))
                            ]
                        }, locker.space_id);
                    })
                }),
                oldList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (RecommendedCoinLockerCardList_module_default()).list,
                    children: oldList.map(function(recommended, index) {
                        var showAdAfterSecondOldOnly = lockers.length === 0 && oldList.length >= 2 && index === 1;
                        var showAdAfterSecondGlobalInOld = lockers.length === 1 && oldList.length >= 1 && index === 0;
                        var showAdEndOnlyOldList = lockers.length === 0 && oldList.length === 1 && index === 0;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            id: "recommended-coin-locker-card-old-".concat(recommended.id),
                            className: (RecommendedCoinLockerCardList_module_default()).listItem,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_RecommendedCoinLockerCardOld, {
                                    coinLocker: recommended,
                                    locale: locale
                                }),
                                showAdLocale && (showAdAfterSecondOldOnly || showAdAfterSecondGlobalInOld || showAdEndOnlyOldList) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdBanner, (0,_object_spread/* default */.Z)({}, NHK_AREA_PAGE_BANNER_CONFIG))
                            ]
                        }, "old-".concat(recommended.id, "-").concat(index));
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (RecommendedCoinLockerCardList_module_default()).noDataText,
            children: t("AREAS.CITY.SLUG.NO_COIN_LOCKER_DATA")
        })
    });
};
/* harmony default export */ var cards_RecommendedCoinLockerCardList = (RecommendedCoinLockerCardList);

// EXTERNAL MODULE: ./node_modules/react-loader-spinner/dist/esm/index.js + 45 modules
var dist_esm = __webpack_require__(51580);
// EXTERNAL MODULE: ./src/components/cards/RecommendedSpaceCardList.module.scss
var RecommendedSpaceCardList_module = __webpack_require__(87727);
var RecommendedSpaceCardList_module_default = /*#__PURE__*/__webpack_require__.n(RecommendedSpaceCardList_module);
// EXTERNAL MODULE: ./src/components/cards/RecommendedSpaceCard.module.scss
var RecommendedSpaceCard_module = __webpack_require__(59743);
var RecommendedSpaceCard_module_default = /*#__PURE__*/__webpack_require__.n(RecommendedSpaceCard_module);
// EXTERNAL MODULE: ./src/components/ratings/RatingCustomComponent.module.scss
var RatingCustomComponent_module = __webpack_require__(3667);
var RatingCustomComponent_module_default = /*#__PURE__*/__webpack_require__.n(RatingCustomComponent_module);
;// CONCATENATED MODULE: ./src/components/ratings/RatingCustomComponent.tsx


var RatingCustomComponent = function(param) {
    var averageRating = param.averageRating, _maxStar = param.maxStar, maxStar = _maxStar === void 0 ? 5 : _maxStar, starSize = param.starSize;
    var width = averageRating / maxStar * 100;
    var startStyle = {};
    if (starSize) {
        startStyle["fontSize"] = "".concat(starSize, "px");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (RatingCustomComponent_module_default()).ratingBox,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (RatingCustomComponent_module_default()).ratingBackground,
                children: Array(maxStar).fill(0).map(function(val, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((RatingCustomComponent_module_default()).ratingStar, " ").concat((RatingCustomComponent_module_default()).ratingBackgroundStar),
                        style: startStyle,
                        children: "★"
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (RatingCustomComponent_module_default()).ratingForeground,
                style: {
                    width: "".concat(width, "%")
                },
                children: Array(maxStar).fill(0).map(function(val, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((RatingCustomComponent_module_default()).ratingStar, " ").concat((RatingCustomComponent_module_default()).ratingForegroundStar),
                        style: startStyle,
                        children: "★"
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var ratings_RatingCustomComponent = (RatingCustomComponent);

;// CONCATENATED MODULE: ./src/hooks/analytics/useCardScrollTracking.ts

var useCardScrollTracking = function(options) {
    var position = options.position, _threshold = options.threshold, threshold = _threshold === void 0 ? 0.5 : _threshold, _rootMargin = options.rootMargin, rootMargin = _rootMargin === void 0 ? "0px" : _rootMargin, _eventName = options.eventName, eventName = _eventName === void 0 ? "card_scroll_tracking" : _eventName, _category = options.category, category = _category === void 0 ? "engagement" : _category, _label = options.label, label = _label === void 0 ? "recommended_space_card" : _label;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isVisible = ref1[0], setIsVisible = ref1[1];
    var ref2 = (0,react.useState)(false), hasTracked = ref2[0], setHasTracked = ref2[1];
    var handleIntersection = (0,react.useCallback)(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting && !hasTracked) {
                setIsVisible(true);
                setHasTracked(true);
                // Google Analyticsにイベント送信
                window.dataLayer.push({
                    event: eventName,
                    event_category: category,
                    event_label: label,
                    value: position,
                    custom_event_type: "scroll"
                });
            }
        });
    }, [
        hasTracked,
        eventName,
        category,
        label,
        position
    ]);
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(handleIntersection, {
            threshold: threshold,
            rootMargin: rootMargin
        });
        var currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return function() {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [
        handleIntersection,
        threshold,
        rootMargin
    ]);
    return {
        ref: ref,
        isVisible: isVisible,
        hasTracked: hasTracked
    };
};

;// CONCATENATED MODULE: ./src/components/cards/RecommendedSpaceCard.tsx








// configs

// components


// hooks

var RecommendedSpaceCard = function(param) {
    var space = param.space, position = param.position;
    var ref, ref1;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref2 = (0,react.useState)(false), isOpenSizePopUp = ref2[0], setIsOpenSizePopUp = ref2[1];
    var locale = (0,next_router.useRouter)().locale;
    var ref3;
    var spaceDetailHref = (0,react.useMemo)(function() {
        return (ref3 = (0,buildSpaceDetailHref/* buildSpaceDetailHref */.d)({
            locale: locale,
            spaceType: "normal",
            spaceUuid: space.id,
            encryptedId: space.encrypted_id
        })) !== null && ref3 !== void 0 ? ref3 : "#";
    }, [
        space.id,
        space.encrypted_id,
        locale
    ]);
    // 個別カードのスクロール追跡
    var ref4 = useCardScrollTracking({
        position: position,
        eventName: "recommended_space_card_scroll",
        category: "engagement",
        label: "recommended_space_card",
        threshold: 0.5
    }), cardRef = ref4.ref, isVisible = ref4.isVisible, hasTracked = ref4.hasTracked;
    var carouselResponsive = {
        desktop: {
            breakpoint: {
                max: 3000,
                min: 992
            },
            items: 1
        },
        tablet: {
            breakpoint: {
                max: 991,
                min: 576
            },
            items: 1
        },
        mobile: {
            breakpoint: {
                max: 575,
                min: 0
            },
            items: 1
        }
    };
    var availabilityIcons = {
        circle: {
            src: "/empty_status_circle_03.svg",
            alt: "◯"
        },
        solid: {
            src: "/empty_status_solid_03.svg",
            alt: "-"
        }
    };
    var getOptimizationBooking = function(booking_data) {
        var rawCapacity = booking_data.capacity;
        var parsedCapacity = typeof rawCapacity === "number" ? rawCapacity : rawCapacity !== undefined && rawCapacity !== null ? Number(rawCapacity) : null;
        var normalizedCapacity = parsedCapacity !== null && !Number.isNaN(parsedCapacity) ? Math.floor(parsedCapacity) : null;
        var rawRatio = booking_data.ratio;
        var ratio = typeof rawRatio === "number" ? rawRatio : rawRatio !== undefined && rawRatio !== null ? Number(rawRatio) : 0;
        var _isHoliday, ref;
        var isHoliday = (ref = (_isHoliday = booking_data.isHoliday) !== null && _isHoliday !== void 0 ? _isHoliday : booking_data.is_holiday) !== null && ref !== void 0 ? ref : false;
        var iconImage = availabilityIcons.circle;
        var remainingLabel = "";
        if (normalizedCapacity !== null) {
            if (normalizedCapacity <= 0) {
                iconImage = availabilityIcons.solid;
            } else if (normalizedCapacity <= 2) {
                iconImage = null;
                remainingLabel = t("AREAS.CITY.SLUG.REMAINING_AVAILABLE_SLOTS", {
                    count: normalizedCapacity
                });
            } else {
                iconImage = availabilityIcons.circle;
            }
        } else {
            if (ratio !== 0) {
                iconImage = availabilityIcons.circle;
            }
        }
        if (ratio >= 100 || isHoliday) {
            iconImage = availabilityIcons.solid;
            remainingLabel = "";
        }
        // 日付のフォーマット
        var _date = new Date(booking_data.date);
        var month = _date.getMonth() + 1;
        var day = _date.getDate();
        var date = "".concat(month, "/").concat(day);
        return {
            date: date,
            iconImage: iconImage,
            remainingLabel: remainingLabel
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (RecommendedSpaceCard_module_default()).spaceCard,
        ref: cardRef,
        children: [
             false && /*#__PURE__*/ 0,
            space.space_photos && space.space_photos.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendedSpaceCard_module_default()).spaceCardMainImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                    ssr: true,
                    responsive: carouselResponsive,
                    infinite: true,
                    swipeable: false,
                    arrows: true,
                    className: (RecommendedSpaceCard_module_default()).spaceCardMainImageList,
                    customLeftArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "".concat((RecommendedSpaceCard_module_default()).spaceCardMainImageListArrow, " ").concat((RecommendedSpaceCard_module_default()).spaceCardMainImageListArrowLeft)
                    }),
                    customRightArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "".concat((RecommendedSpaceCard_module_default()).spaceCardMainImageListArrow, " ").concat((RecommendedSpaceCard_module_default()).spaceCardMainImageListArrowRight)
                    }),
                    children: space.space_photos.map(function(photo, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RecommendedSpaceCard_module_default()).spaceCardMainImageListItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (RecommendedSpaceCard_module_default()).spaceCardMainImageImage,
                                src: photo.url,
                                alt: photo.photo_description ? photo.photo_description : ""
                            })
                        }, index);
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendedSpaceCard_module_default()).spaceCardMainImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (RecommendedSpaceCard_module_default()).spaceCardMainImageListItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (RecommendedSpaceCard_module_default()).spaceCardMainImageImage,
                        src: "/location_popular_area_default.webp",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendedSpaceCard_module_default()).spaceCardContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: spaceDetailHref,
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: (RecommendedSpaceCard_module_default()).spaceCardContentLink,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (RecommendedSpaceCard_module_default()).spaceCardTitle,
                                children: space.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (RecommendedSpaceCard_module_default()).spaceCardDistanceTime,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (RecommendedSpaceCard_module_default()).spaceCardDistanceTimeText,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (RecommendedSpaceCard_module_default()).spaceCardDistanceTimeImage,
                                                src: "/map_pin_icon_gray.svg",
                                                alt: ""
                                            }),
                                            t("COMMON.HOW_MANY_MINUTES_WALK_FROM_THE_STATION", {
                                                stationName: space.station_1_name,
                                                minutes: space.distance_from_station_1
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (RecommendedSpaceCard_module_default()).spaceCardDistanceTimeText,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (RecommendedSpaceCard_module_default()).spaceCardDistanceTimeImage,
                                                src: "/business_hours_icon_gray.svg",
                                                alt: ""
                                            }),
                                            t("COMMON.TODAY_BUSINESS_TIME"),
                                            " :",
                                            " ",
                                            space.available_24_hour ? t("SPACES.LABEL.OPEN_24_HOURS") : space.open_at_today || space.close_at_today ? "".concat(space.open_at_today, "〜").concat(space.close_at_today) : t("SPACES.LABEL.CLOSED")
                                        ]
                                    })
                                ]
                            }),
                            !!space.reviews && !!space.reviews.total_review_count && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (RecommendedSpaceCard_module_default()).spaceCardReview,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (RecommendedSpaceCard_module_default()).spaceCardReviewData,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (RecommendedSpaceCard_module_default()).spaceCardReviewDataAverage,
                                                children: (space.reviews.average_review || 0).toFixed(1)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (RecommendedSpaceCard_module_default()).spaceCardReviewDataStar,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ratings_RatingCustomComponent, {
                                                    averageRating: space.reviews.average_review,
                                                    maxStar: 5,
                                                    starSize: 12
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (RecommendedSpaceCard_module_default()).spaceCardReviewDataTotal,
                                                children: t("COMMON.TOTAL_REVIEWS", {
                                                    total: space.reviews.total_review_count
                                                })
                                            })
                                        ]
                                    }),
                                    !!((ref = space.reviews.comment) === null || ref === void 0 ? void 0 : ref.trim()) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (RecommendedSpaceCard_module_default()).spaceCardReviewComment,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (RecommendedSpaceCard_module_default()).spaceCardReviewCommentText,
                                            children: space.reviews.comment
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendedSpaceCard_module_default()).spaceCardSize,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                    className: (RecommendedSpaceCard_module_default()).spaceCardSizeContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                            className: (RecommendedSpaceCard_module_default()).spaceCardSizeTitle,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: spaceDetailHref,
                                    legacyBehavior: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (RecommendedSpaceCard_module_default()).spaceCardSizeTitleLink,
                                        children: t("COMMON.CAN_STORE_LUGGAGE_COUNT")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (RecommendedSpaceCard_module_default()).spaceCardSizeTitleIcon,
                                    onClick: function() {
                                        setIsOpenSizePopUp(!isOpenSizePopUp);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (RecommendedSpaceCard_module_default()).spaceCardSizeTitleImage,
                                            src: "/question_icon_gray.svg",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((RecommendedSpaceCard_module_default()).spaceCardSizeSizePopUp, " ").concat(isOpenSizePopUp ? (RecommendedSpaceCard_module_default()).spaceCardSizeSizePopUpOpen : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RecommendedSpaceCard_module_default()).spaceCardSizeSizePopUpClose,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: (RecommendedSpaceCard_module_default()).spaceCardSizeSizePopUpCloseButton,
                                                        onClick: function() {
                                                            setIsOpenSizePopUp(false);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/close_icon_black.svg",
                                                            alt: ""
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanCard, {
                                                    title: t("AREAS.CITY.SLUG.PLAN_BAG_SIZE"),
                                                    countryCode: "jpn",
                                                    iconImage: "/plan_size_bag.webp",
                                                    sizeType: configs_space/* PRICE_SIZE_TYPE_BAG */.F$,
                                                    description: t("AREAS.CITY.SLUG.PLAN_BAG_DESCRIPTION"),
                                                    price: space.prices.bag_size
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanCard, {
                                                    title: t("AREAS.CITY.SLUG.PLAN_SUIT_SIZE"),
                                                    countryCode: "jpn",
                                                    iconImage: "/plan_size_suitcase.webp",
                                                    sizeType: configs_space/* PRICE_SIZE_TYPE_SUITCASE */.TD,
                                                    description: t("AREAS.CITY.SLUG.PLAN_SUIT_DESCRIPTION"),
                                                    price: space.prices.suitecase_size
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                            className: (RecommendedSpaceCard_module_default()).spaceCardSizeDescription,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: spaceDetailHref,
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: (RecommendedSpaceCard_module_default()).spaceCardSizeDescriptionLink,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (RecommendedSpaceCard_module_default()).spaceCardSizeInfo,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: (RecommendedSpaceCard_module_default()).spaceCardSizeInfoImage,
                                                    src: "/luggage_icon.svg",
                                                    alt: ""
                                                }),
                                                t("COMMON.SUITECASE_SIZE"),
                                                " :",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: (RecommendedSpaceCard_module_default()).spaceCardSizeInfoCount,
                                                    children: space.suitcase_size
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (RecommendedSpaceCard_module_default()).spaceCardSizeInfo,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: (RecommendedSpaceCard_module_default()).spaceCardSizeInfoImage,
                                                    src: "/bag_icon_black.svg",
                                                    alt: ""
                                                }),
                                                t("COMMON.BAG_SIZE"),
                                                " :",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: (RecommendedSpaceCard_module_default()).spaceCardSizeInfoCount,
                                                    children: space.bag_size
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RecommendedSpaceCard_module_default()).spaceCardEmpty,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: spaceDetailHref,
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (RecommendedSpaceCard_module_default()).spaceCardEmptyLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTable,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTableItem, " ").concat((RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTableLabel),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTableLabelText,
                                        children: t("COMMON.AVAILABILITY_TIME")
                                    })
                                }),
                                (ref1 = space.bookings) === null || ref1 === void 0 ? void 0 : ref1.map(function(booking, index) {
                                    var bookingData = getOptimizationBooking(booking);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTableItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTableTh, " ").concat(booking.day_of_week_label === "Sat" ? (RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTableThSaturday : "", " ").concat(booking.day_of_week_label === "Sun" ? (RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTableThSunday : ""),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTableDate,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: bookingData.date
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: booking.day_of_week
                                                        })
                                                    ]
                                                })
                                            }, index),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTableTd,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTableTdIcon,
                                                    children: bookingData.iconImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: bookingData.iconImage.src,
                                                        alt: bookingData.iconImage.alt
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (RecommendedSpaceCard_module_default()).spaceCardEmptyCalendarTableTdLabel,
                                                        children: bookingData.remainingLabel || "\xa0"
                                                    })
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (RecommendedSpaceCard_module_default()).spaceCardReserve,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: spaceDetailHref,
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (RecommendedSpaceCard_module_default()).spaceCardReserveButtonLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (RecommendedSpaceCard_module_default()).spaceCardReserveButton,
                            children: t("COMMON.RESERVE_THIS_SPACE")
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var cards_RecommendedSpaceCard = (RecommendedSpaceCard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/Pagination/styles.module.css
var Pagination_styles_module = __webpack_require__(37895);
var Pagination_styles_module_default = /*#__PURE__*/__webpack_require__.n(Pagination_styles_module);
// EXTERNAL MODULE: ./node_modules/react-icons/fa6/index.mjs
var fa6 = __webpack_require__(86204);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ./src/components/Pagination/index.tsx









var Pagination = function(param) {
    var page = param.page, total = param.total, onChangePage = param.onChangePage;
    var ref = (0,react.useState)(page), currentPage = ref[0], setCurrentPage = ref[1];
    var router = (0,next_router.useRouter)();
    var handleChangePage = (0,react.useMemo)(function() {
        return lodash_debounce_default()(function(selectedPage) {
            onChangePage(selectedPage);
        }, 500);
    }, [
        onChangePage
    ]);
    var getPageUrl = function(pageNum) {
        var currentPath = router.asPath.split("?")[0];
        // router.queryからNext.jsの動的ルートパラメータ（country, slugなど）を除外
        var _query = router.query, country = _query.country, slug = _query.slug, actualQueryParams = (0,_object_without_properties/* default */.Z)(_query, [
            "country",
            "slug"
        ]);
        if (pageNum === 1) {
            delete actualQueryParams.page;
        } else {
            actualQueryParams.page = pageNum.toString();
        }
        var queryString = Object.keys(actualQueryParams).length > 0 ? "?" + new URLSearchParams(actualQueryParams).toString() : "";
        return (0,addLocalePrefix/* addLocalePrefix */.Le)("".concat(currentPath).concat(queryString), router.locale);
    };
    var renderPaging = (0,react.useMemo)(function() {
        if (total <= 1) return null;
        var renderPage = function(pageIndex) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                page: pageIndex,
                active: currentPage === pageIndex,
                getPageUrl: getPageUrl,
                onChangePage: function(_page) {
                    setCurrentPage(_page);
                    handleChangePage(_page);
                }
            }, pageIndex);
        };
        // Show all pages when total is small enough that ellipsis is unnecessary
        if (total <= 7) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: Array.from({
                    length: total
                }, function(_, i) {
                    return i + 1;
                }).map(renderPage)
            });
        }
        // Window: current ±2, expanded towards boundaries to always show at least 5 pages
        var windowStart = Math.max(1, Math.min(currentPage - 2, total - 4));
        var windowEnd = Math.min(total, Math.max(currentPage + 2, 5));
        // Middle pages, excluding always-shown page 1 and last page
        var rangeStart = Math.max(2, windowStart);
        var rangeEnd = Math.min(total - 1, windowEnd);
        var middlePages = rangeStart <= rangeEnd ? Array.from({
            length: rangeEnd - rangeStart + 1
        }, function(_, i) {
            return rangeStart + i;
        }) : [];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                renderPage(1),
                windowStart > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Pagination_styles_module_default()).ellipsis,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa6/* FaEllipsis */.b8G, {
                        size: 20,
                        color: "#0B6AB3"
                    })
                }),
                middlePages.map(renderPage),
                windowEnd < total - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Pagination_styles_module_default()).ellipsis,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa6/* FaEllipsis */.b8G, {
                        size: 20,
                        color: "#0B6AB3"
                    })
                }),
                renderPage(total)
            ]
        });
    }, [
        currentPage,
        handleChangePage,
        total,
        router.asPath,
        router.query,
        router.locale
    ]);
    if (total <= 1) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Pagination_styles_module_default()).container,
        children: [
            currentPage === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat((Pagination_styles_module_default()).chevronButton, " ").concat((Pagination_styles_module_default()).disabled),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa6/* FaChevronLeft */.bUI, {
                    size: 13,
                    color: "#e4e4e4"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: getPageUrl(currentPage - 1),
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (Pagination_styles_module_default()).chevronButton,
                    onClick: function(e) {
                        e.preventDefault();
                        var _page = currentPage - 1;
                        setCurrentPage(_page);
                        handleChangePage(_page);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa6/* FaChevronLeft */.bUI, {
                        size: 13,
                        color: "#0B6AB3"
                    })
                })
            }),
            renderPaging,
            currentPage === total ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat((Pagination_styles_module_default()).chevronButton, " ").concat((Pagination_styles_module_default()).disabled),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa6/* FaChevronRight */.Dli, {
                    size: 13,
                    color: "#e4e4e4"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: getPageUrl(currentPage + 1),
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (Pagination_styles_module_default()).chevronButton,
                    onClick: function(e) {
                        e.preventDefault();
                        var _page = currentPage + 1;
                        setCurrentPage(_page);
                        handleChangePage(_page);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa6/* FaChevronRight */.Dli, {
                        size: 13,
                        color: "#0B6AB3"
                    })
                })
            })
        ]
    });
};
var Page = function(param) {
    var page = param.page, active = param.active, getPageUrl = param.getPageUrl, onChangePage = param.onChangePage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: getPageUrl(page),
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "".concat((Pagination_styles_module_default()).pageContainer, " ").concat(active ? (Pagination_styles_module_default()).pageActiveContainer : ""),
            onClick: function(e) {
                e.preventDefault();
                onChangePage(page);
            },
            "aria-current": active ? "page" : undefined,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: page
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/cards/RecommendedSpaceCardList.tsx






//component




var RecommendedSpaceCardList = function(param) {
    var list = param.list, totalCount = param.totalCount, _currentPage = param.currentPage, currentPage = _currentPage === void 0 ? 1 : _currentPage, _itemsPerPage = param.itemsPerPage, itemsPerPage = _itemsPerPage === void 0 ? 10 : _itemsPerPage, onPageChange = param.onPageChange, _usePagination = param.usePagination, usePagination = _usePagination === void 0 ? false : _usePagination, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, locale = param.locale;
    var t = (0,esm/* useTranslation */.$G)().t;
    var showAdLocale = locale === "en" || locale === "zh_tw";
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (RecommendedSpaceCardList_module_default()).loading,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* TailSpin */.gy, {
                height: "100",
                width: "100",
                color: "#0b6ab3",
                ariaLabel: "loading"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (RecommendedSpaceCardList_module_default()).list,
                children: list.map(function(recommended, index) {
                    var showAdAfterSecond = list.length >= 2 && index === 1;
                    var showAdAtEndShortList = list.length === 1 && index === 0;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: (RecommendedSpaceCardList_module_default()).listItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_RecommendedSpaceCard, {
                                space: recommended,
                                position: index + 1
                            }),
                            showAdLocale && (showAdAfterSecond || showAdAtEndShortList) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdBanner, (0,_object_spread/* default */.Z)({}, NHK_AREA_PAGE_BANNER_CONFIG))
                        ]
                    }, index);
                })
            }),
            totalCount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (RecommendedSpaceCardList_module_default()).noDataText,
                children: t("AREAS.CITY.SLUG.NO_LUGGAGE_DATA")
            }) : null,
            usePagination && onPageChange && totalCount > itemsPerPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
                page: currentPage,
                total: Math.ceil(totalCount / itemsPerPage),
                onChangePage: onPageChange
            })
        ]
    });
};
/* harmony default export */ var cards_RecommendedSpaceCardList = (/*#__PURE__*/(0,react.memo)(RecommendedSpaceCardList));

// EXTERNAL MODULE: ./src/components/domains/country/city/slug/CoinLockerMapSection.module.scss
var CoinLockerMapSection_module = __webpack_require__(64984);
var CoinLockerMapSection_module_default = /*#__PURE__*/__webpack_require__.n(CoinLockerMapSection_module);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var api_dist_esm = __webpack_require__(37054);
// EXTERNAL MODULE: ./src/lib/customGoogleMapOptions.ts
var customGoogleMapOptions = __webpack_require__(75617);
;// CONCATENATED MODULE: ./src/components/maps/CoinLockerMapComponent.tsx




var CoinLockerMapComponent = function(param) {
    var lat = param.lat, lon = param.lon, zoomLabel = param.zoomLabel, coinLockers = param.coinLockers, _oldCoinLockers = param.oldCoinLockers, oldCoinLockers = _oldCoinLockers === void 0 ? [] : _oldCoinLockers, mapRef = param.mapRef, initGoogleMap = param.initGoogleMap, scrollToRecommendedCoinLockerSection = param.scrollToRecommendedCoinLockerSection;
    var ref = (0,checkBreakpoint/* default */.Z)(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    var _googleMapOptions = {
        fullscreenControl: false,
        zoomControl: !isTablet && !isMobile || false,
        zoomControlOptions: {
            position: 1
        },
        styles: customGoogleMapOptions/* GoogleMapOptions */.v,
        disableDefaultUI: true,
        minZoom: 6,
        maxZoom: 16
    };
    // Ensure we have arrays to avoid issues
    var regularLockers = Array.isArray(coinLockers) ? coinLockers : [];
    var oldLockers = Array.isArray(oldCoinLockers) ? oldCoinLockers : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(api_dist_esm/* GoogleMap */.b6, {
            ref: mapRef,
            mapContainerStyle: {
                width: "100%",
                height: "100%",
                paddingTop: isMobile ? "100%" : "50.27%"
            },
            center: {
                lat: lat,
                lng: lon
            },
            zoom: zoomLabel,
            options: _googleMapOptions,
            onLoad: function(map) {
                return initGoogleMap(map);
            },
            children: [
                regularLockers.map(function(coinLocker, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(api_dist_esm/* Marker */.Jx, {
                        position: {
                            lat: parseFloat(coinLocker.latitude),
                            lng: parseFloat(coinLocker.longitude)
                        },
                        icon: "/marker_coin_locker.svg",
                        onClick: function() {
                            scrollToRecommendedCoinLockerSection(coinLocker.id, false);
                        }
                    }, "regular-".concat(index));
                }),
                oldLockers.map(function(coinLocker, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(api_dist_esm/* Marker */.Jx, {
                        position: {
                            lat: parseFloat(coinLocker.latitude),
                            lng: parseFloat(coinLocker.longitude)
                        },
                        icon: "/marker_coin_locker.svg",
                        onClick: function() {
                            scrollToRecommendedCoinLockerSection(coinLocker.id, true);
                        }
                    }, "old-".concat(index));
                })
            ]
        })
    });
};
/* harmony default export */ var maps_CoinLockerMapComponent = (CoinLockerMapComponent);

// EXTERNAL MODULE: ./src/hooks/logger/useGoogleMapLogger.ts
var useGoogleMapLogger = __webpack_require__(57519);
;// CONCATENATED MODULE: ./src/components/domains/country/city/slug/CoinLockerMapSection.tsx





var CoinLockerMapSection = function(param) {
    var centerLat = param.centerLat, centerLon = param.centerLon, coinLockers = param.coinLockers, _oldCoinLockers = param.oldCoinLockers, oldCoinLockers = _oldCoinLockers === void 0 ? [] : _oldCoinLockers, scrollToRecommendedCoinLockerSection = param.scrollToRecommendedCoinLockerSection;
    var mapRef = (0,react.useRef)(null);
    var logGoogleMapUsage = (0,useGoogleMapLogger/* useGoogleMapLogger */.y)().logGoogleMapUsage;
    // const zoom = 16
    var initGoogleMap = function(map) {
        mapRef.current = map;
        logGoogleMapUsage({
            timestamp: new Date().toISOString(),
            screen: window.location.pathname,
            env: "staging" || 0,
            platform: "web",
            action_type: "load_map",
            api_sku: "Dynamic Maps",
            latitude: centerLat,
            longitude: centerLon,
            user_input_text: ""
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CoinLockerMapSection_module_default()).section,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(maps_CoinLockerMapComponent, {
            lat: centerLat,
            lon: centerLon,
            zoomLabel: 16,
            coinLockers: coinLockers,
            oldCoinLockers: oldCoinLockers,
            mapRef: mapRef,
            initGoogleMap: initGoogleMap,
            scrollToRecommendedCoinLockerSection: scrollToRecommendedCoinLockerSection
        })
    });
};
/* harmony default export */ var slug_CoinLockerMapSection = (CoinLockerMapSection);

// EXTERNAL MODULE: ./src/components/domains/country/city/slug/SearchForm.module.scss
var SearchForm_module = __webpack_require__(85985);
var SearchForm_module_default = /*#__PURE__*/__webpack_require__.n(SearchForm_module);
// EXTERNAL MODULE: ./node_modules/react-dates/index.js
var react_dates = __webpack_require__(76141);
// EXTERNAL MODULE: ./src/components/calendars/DateRangeCalendarSimpleComponent.module.scss
var DateRangeCalendarSimpleComponent_module = __webpack_require__(51323);
var DateRangeCalendarSimpleComponent_module_default = /*#__PURE__*/__webpack_require__.n(DateRangeCalendarSimpleComponent_module);
// EXTERNAL MODULE: ./src/utils/calendar.ts
var calendar = __webpack_require__(60849);
;// CONCATENATED MODULE: ./src/components/calendars/DateRangeCalendarSimpleComponent.tsx






moment_default().locale("ja");


var DateRangeCalendarComponent = function(param) {
    var onPressCloseModalRequest = param.onPressCloseModalRequest, selectedDate = param.selectedDate, setSelectedDate = param.setSelectedDate, page = param.page;
    var ref = (0,react.useState)(null), focused = ref[0], setFocused = ref[1];
    var isMobile = (0,checkBreakpoint/* default */.Z)().isMobile;
    var i18n = (0,esm/* useTranslation */.$G)().i18n;
    var placeHolderStart = moment_default()(new Date()).format("MM/DD");
    var placeHolderEnd = placeHolderStart;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dates.DateRangePicker, {
        readOnly: true,
        numberOfMonths: isMobile ? 1 : 2,
        startDatePlaceholderText: placeHolderStart,
        endDatePlaceholderText: placeHolderEnd,
        monthFormat: i18n.language === "en" ? "YYYY MMMM" : "YYYY[年]MM[月]",
        startDate: selectedDate.startDate,
        endDate: selectedDate.endDate,
        startDateId: "start",
        endDateId: "end",
        focusedInput: focused,
        onDatesChange: function(param) {
            var startDate = param.startDate, endDate = param.endDate;
            setSelectedDate({
                startDate: startDate,
                endDate: endDate
            });
        },
        onFocusChange: function(focusedInput) {
            return setFocused(focusedInput);
        },
        verticalSpacing: 0,
        navPrev: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (DateRangeCalendarSimpleComponent_module_default()).prev
        }),
        navNext: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (DateRangeCalendarSimpleComponent_module_default()).next
        }),
        isOutsideRange: function(day) {
            return day.isSameOrAfter(moment_default()().add(3, "month")) || !(0,react_dates.isInclusivelyAfterDay)(day, moment_default()());
        },
        hideKeyboardShortcutsPanel: true,
        renderCalendarInfo: function() {
            return undefined;
        },
        minimumNights: 0,
        displayFormat: "MM/DD",
        customArrowIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "-"
        }),
        renderWeekHeaderElement: function(day) {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (DateRangeCalendarSimpleComponent_module_default()).weekHeader,
                children: calendar/* calendarWeekHeader */.Y === null || calendar/* calendarWeekHeader */.Y === void 0 ? void 0 : (ref = calendar/* calendarWeekHeader */.Y[day]) === null || ref === void 0 ? void 0 : ref[i18n.language]
            });
        }
    });
};
/* harmony default export */ var DateRangeCalendarSimpleComponent = (DateRangeCalendarComponent);

// EXTERNAL MODULE: ./src/components/buttons/LuggageButtonComponent.tsx
var LuggageButtonComponent = __webpack_require__(13951);
;// CONCATENATED MODULE: ./node_modules/react-cool-onclickoutside/dist/index.esm.js


var canUsePassiveEvents = (function () {
  if (typeof window === "undefined" || typeof window.addEventListener !== "function") return false;
  var passive = false;
  var options = Object.defineProperty({}, "passive", {
    // eslint-disable-next-line getter-return
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {
    return null;
  };

  window.addEventListener("test", noop, options);
  window.removeEventListener("test", noop, options);
  return passive;
});

var DEFAULT_IGNORE_CLASS = "ignore-onclickoutside";

var checkClass = function checkClass(el, cl) {
  var _el$classList;

  return (_el$classList = el.classList) == null ? void 0 : _el$classList.contains(cl);
};

var hasIgnoreClass = function hasIgnoreClass(e, ignoreClass) {
  var el = e.target || e;

  while (el) {
    if (Array.isArray(ignoreClass)) {
      // eslint-disable-next-line no-loop-func
      if (ignoreClass.some(function (c) {
        return checkClass(el, c);
      })) return true;
    } else if (checkClass(el, ignoreClass)) {
      return true;
    }

    el = el.parentElement;
  }

  return false;
};

var clickedOnScrollbar = function clickedOnScrollbar(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
};

var getEventOptions = function getEventOptions(type) {
  return type.includes("touch") && canUsePassiveEvents() ? {
    passive: true
  } : false;
};

var useOnclickOutside = function useOnclickOutside(callback, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      refsOpt = _ref.refs,
      disabled = _ref.disabled,
      _ref$eventTypes = _ref.eventTypes,
      eventTypes = _ref$eventTypes === void 0 ? ["mousedown", "touchstart"] : _ref$eventTypes,
      excludeScrollbar = _ref.excludeScrollbar,
      _ref$ignoreClass = _ref.ignoreClass,
      ignoreClass = _ref$ignoreClass === void 0 ? DEFAULT_IGNORE_CLASS : _ref$ignoreClass,
      _ref$detectIFrame = _ref.detectIFrame,
      detectIFrame = _ref$detectIFrame === void 0 ? true : _ref$detectIFrame;

  var _useState = (0,react.useState)([]),
      refsState = _useState[0],
      setRefsState = _useState[1];

  var callbackRef = (0,react.useRef)(callback);
  callbackRef.current = callback;
  var ref = (0,react.useCallback)(function (el) {
    return setRefsState(function (prevState) {
      return [].concat(prevState, [{
        current: el
      }]);
    });
  }, []);
  (0,react.useEffect)(function () {
    if (!(refsOpt != null && refsOpt.length) && !refsState.length) return;

    var getEls = function getEls() {
      var els = [];
      (refsOpt || refsState).forEach(function (_ref2) {
        var current = _ref2.current;
        return current && els.push(current);
      });
      return els;
    };

    var handler = function handler(e) {
      if (!hasIgnoreClass(e, ignoreClass) && !(excludeScrollbar && clickedOnScrollbar(e)) && getEls().every(function (el) {
        return !el.contains(e.target);
      })) callbackRef.current(e);
    };

    var blurHandler = function blurHandler(e) {
      return (// On firefox the iframe becomes document.activeElement in the next event loop
        setTimeout(function () {
          var _document = document,
              activeElement = _document.activeElement;
          if ((activeElement == null ? void 0 : activeElement.tagName) === "IFRAME" && !hasIgnoreClass(activeElement, ignoreClass) && !getEls().includes(activeElement)) callbackRef.current(e);
        }, 0)
      );
    };

    var removeEventListener = function removeEventListener() {
      eventTypes.forEach(function (type) {
        return (// @ts-expect-error
          document.removeEventListener(type, handler, getEventOptions(type))
        );
      });
      if (detectIFrame) window.removeEventListener("blur", blurHandler);
    };

    if (disabled) {
      removeEventListener();
      return;
    }

    eventTypes.forEach(function (type) {
      return document.addEventListener(type, handler, getEventOptions(type));
    });
    if (detectIFrame) window.addEventListener("blur", blurHandler); // eslint-disable-next-line consistent-return

    return function () {
      return removeEventListener();
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [refsState, ignoreClass, excludeScrollbar, disabled, detectIFrame, // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(eventTypes)]);
  return ref;
};

/* harmony default export */ var index_esm = (useOnclickOutside);


// EXTERNAL MODULE: ./src/features/places/hooks/usePlaceAutoCompletion.ts + 1 modules
var usePlaceAutoCompletion = __webpack_require__(21546);
// EXTERNAL MODULE: ./src/features/tracking/lib/location.ts
var lib_location = __webpack_require__(45060);
;// CONCATENATED MODULE: ./src/components/domains/country/city/slug/SearchForm.tsx








//component






var SearchForm = function(param) {
    var name = param.name, latitude = param.latitude, longitude = param.longitude;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)({
        startDate: null,
        endDate: null
    }), selectedDate = ref[0], setSelectedDate = ref[1];
    var ref1 = (0,react.useState)({
        lat: latitude,
        lon: longitude
    }), latLng = ref1[0], setLatLng = ref1[1];
    var ref2 = (0,react.useState)(0), bagSizeStepper = ref2[0], setBagSizeStepper = ref2[1];
    var ref3 = (0,react.useState)(0), suitcaseSizeStepper = ref3[0], setSuitcaseSizeStepper = ref3[1];
    var ref4 = (0,react.useState)(false), isSearchButtonEnabled = ref4[0], setIsSearchButtonEnabled = ref4[1];
    var ref5 = (0,react.useState)(false), openLuggage = ref5[0], setOpenLuggage = ref5[1];
    var ref6 = (0,react.useState)(false), openSuggest = ref6[0], setOpenSuggest = ref6[1];
    var ref7 = (0,react.useState)(false), hasSelectedPlace = ref7[0], setHasSelectedPlace = ref7[1];
    var luggageRef = (0,react.useRef)(null);
    var ref8 = (0,usePlaceAutoCompletion/* usePlaceAutoCompletion */.s)(), places = ref8.places, status = ref8.status, setPlaces = ref8.setPlaces, setSearchText = ref8.setSearchText, setSearchTextFromInput = ref8.setSearchTextFromInput, selectPlace = ref8.selectPlace;
    var ref9 = (0,react.useState)(""), inputText = ref9[0], setInputText = ref9[1];
    var _onPressLuggageContainer = (0,react.useCallback)(function(event) {
        luggageRef.current.contains(event.target) ? setOpenLuggage(true) : setOpenLuggage(false);
    }, []);
    var _onPressNavigationSearchSpacePage = (0,react.useCallback)(function(value, selectedDate, bagSize, suitcaseSize, lat, lon, isLocation) {
        var startDate = selectedDate.startDate === null ? null : selectedDate.startDate.format("yyyy-MM-DD");
        var endDate = selectedDate.endDate === null ? null : selectedDate.endDate.format("yyyy-MM-DD");
        router.push({
            pathname: "/locations",
            query: {
                name: value,
                startDate: startDate,
                endDate: endDate,
                bagSize: bagSize,
                suitcaseSize: suitcaseSize,
                lat: lat,
                lon: lon,
                isLocation: isLocation
            }
        });
    }, []);
    /**
   * 初期化処理
   */ (0,react.useEffect)(function() {
        //remove LuggageContainer on Clicked out side of dom
        document.addEventListener("click", _onPressLuggageContainer);
        return function() {
            document.removeEventListener("click", _onPressLuggageContainer);
        };
    }, []);
    /**
   * 初期化処理
   * name検知
   */ (0,react.useEffect)(function() {
        // Initial set name if you have a name
        setInputText(name);
        setSearchText(name);
    }, [
        name,
        setSearchText
    ]);
    //update isSearchButtonEnabled
    (0,react.useEffect)(function() {
        var enabled = inputText === "" && (selectedDate.startDate === null || selectedDate.endDate === null) && bagSizeStepper === 0 && suitcaseSizeStepper === 0 ? false : true;
        setIsSearchButtonEnabled(enabled);
    }, [
        selectedDate,
        bagSizeStepper,
        suitcaseSizeStepper,
        inputText
    ]);
    var handleInput = function(e) {
        var text = e.target.value;
        setInputText(text);
        setSearchTextFromInput(text);
        // Processing of suggestion display control when page is displayed.
        if (!openSuggest) return setOpenSuggest(true);
    };
    var _handleSelect = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(place) {
            var geocode, lat, lng;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setInputText(place.description);
                        setSearchText("");
                        setPlaces([]);
                        return [
                            4,
                            selectPlace(place)
                        ];
                    case 1:
                        geocode = _state.sent();
                        if (geocode) {
                            lat = geocode.lat, lng = geocode.lng;
                            setLatLng({
                                lat: lat,
                                lon: lng
                            });
                            setHasSelectedPlace(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(place) {
            return _ref.apply(this, arguments);
        };
    }(), [
        selectPlace,
        setPlaces,
        setSearchText
    ]);
    var _onPressSearchContainer = index_esm(function() {
        setPlaces([]);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchForm_module_default()).search,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SearchForm_module_default()).searchContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((SearchForm_module_default()).searchInput, " ").concat((SearchForm_module_default()).searchInputArea),
                        ref: _onPressSearchContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (SearchForm_module_default()).searchInputAreaIcon,
                                src: "/search_placeholder_icon.svg",
                                alt: t("META.PLACEHOLDER_SEARCH_ICON")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (SearchForm_module_default()).searchInputFormWrap,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        value: inputText,
                                        onChange: handleInput,
                                        placeholder: t("SPACES.SEARCH.AREA.PLACEHOLDER"),
                                        className: "".concat((SearchForm_module_default()).searchInputForm, " ").concat((SearchForm_module_default()).searchInputAreaForm)
                                    }),
                                    openSuggest && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            status === "OK" && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: (SearchForm_module_default()).suggest,
                                                children: places.map(function(suggestion) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        onClick: function() {
                                                            return _handleSelect(suggestion);
                                                        },
                                                        className: (SearchForm_module_default()).suggestText,
                                                        children: suggestion.description
                                                    }, suggestion.place_id);
                                                })
                                            }),
                                            status === "ZERO_RESULTS" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (SearchForm_module_default()).noResult,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (SearchForm_module_default()).noResultText,
                                                    children: t("SPACES.SEARCH.AREA.NO_RESULT")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (SearchForm_module_default()).searchInputDateSizeCount,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((SearchForm_module_default()).searchInput, " ").concat((SearchForm_module_default()).searchInputDate),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (SearchForm_module_default()).searchInputDateImage,
                                        src: "/calendar_placeholder_icon.svg",
                                        alt: t("META.PLACEHOLDER_CALENDAR_ICON")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (SearchForm_module_default()).searchInputFormWrap,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangeCalendarSimpleComponent, {
                                            onPressCloseModalRequest: function() {},
                                            selectedDate: selectedDate,
                                            setSelectedDate: setSelectedDate
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((SearchForm_module_default()).searchInput, " ").concat((SearchForm_module_default()).searchInputSizeCount),
                                onClick: _onPressLuggageContainer,
                                ref: luggageRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (SearchForm_module_default()).searchInputFormWrap,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (SearchForm_module_default()).searchInputSizeCountSuitcase,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: (SearchForm_module_default()).searchInputSizeCountSuitcaseImage,
                                                        src: "/suitcase_icon_gray_no_margin.svg",
                                                        alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                                    }),
                                                    "x ".concat(suitcaseSizeStepper)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (SearchForm_module_default()).searchInputSizeCountBag,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: (SearchForm_module_default()).searchInputSizeCountBagImage,
                                                        src: "/bag_icon_gray.svg",
                                                        alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                                    }),
                                                    "x ".concat(bagSizeStepper)
                                                ]
                                            })
                                        ]
                                    }),
                                    openLuggage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (SearchForm_module_default()).luggageContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (SearchForm_module_default()).luggageContainerBagSize,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (SearchForm_module_default()).counter,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (SearchForm_module_default()).counterLabel,
                                                                children: t("COMMON.BAG_SIZE")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LuggageButtonComponent/* default */.Z, {
                                                                sizeStepper: bagSizeStepper,
                                                                setSizeStepper: setBagSizeStepper
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (SearchForm_module_default()).description,
                                                        children: t("SPACES.SEARCH.LUGGAGE.BAG_SIZE_DESCRIPTION")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (SearchForm_module_default()).luggageContainerSuitecaseSize,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (SearchForm_module_default()).counter,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (SearchForm_module_default()).counterLabel,
                                                                children: t("COMMON.SUITECASE_SIZE")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LuggageButtonComponent/* default */.Z, {
                                                                sizeStepper: suitcaseSizeStepper,
                                                                setSizeStepper: setSuitcaseSizeStepper
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (SearchForm_module_default()).description,
                                                        children: t("SPACES.SEARCH.LUGGAGE.SUITECASE_SIZE_DESCRIPTION")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SearchForm_module_default()).searchButtonWrap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "".concat((SearchForm_module_default()).searchButton, " ").concat(isSearchButtonEnabled ? "" : (SearchForm_module_default()).searchButtonDisabled),
                    onClick: function() {
                        if (!isSearchButtonEnabled) {
                            return;
                        }
                        var lat = latLng.lat || latitude;
                        var lon = latLng.lon || longitude;
                        // 候補を選ばずにエリアページの地点のまま検索した場合は、アプリのプリセットエリア選択と同じイベントを送る
                        if (!hasSelectedPlace) {
                            (0,gtag/* sendGtmLocationEvent */.Tw)(gtag/* GTM_EVENT_DEFAULT_ADDRESS_SEARCH */.oC, (0,_object_spread/* default */.Z)({
                                search_keyword: name
                            }, (0,lib_location/* toAnalyticsLocation */.N)(Number(lat), Number(lon))));
                        }
                        _onPressNavigationSearchSpacePage(inputText || name, selectedDate, bagSizeStepper, suitcaseSizeStepper, lat, lon);
                    },
                    children: t("AREAS.CITY.SLUG.SEARCH_SEE_NEARBY_BUTTON")
                })
            })
        ]
    });
};
/* harmony default export */ var slug_SearchForm = (SearchForm);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/domains/spaces/Qa.module.scss
var Qa_module = __webpack_require__(97603);
var Qa_module_default = /*#__PURE__*/__webpack_require__.n(Qa_module);
// EXTERNAL MODULE: ./src/components/icons/AccordionIconComponent.tsx
var AccordionIconComponent = __webpack_require__(6565);
;// CONCATENATED MODULE: ./src/components/domains/spaces/Qa.tsx







var Qa = function(param) {
    var locationName = param.locationName, id = param.id, ignoreIds = param.ignoreIds, _useWithAreaTranslations = param.useWithAreaTranslations, useWithAreaTranslations = _useWithAreaTranslations === void 0 ? false : _useWithAreaTranslations;
    var t = (0,esm/* useTranslation */.$G)().t;
    var getQuestionDescription = function(defaultKey, withAreaKey, options) {
        return t(useWithAreaTranslations ? withAreaKey : defaultKey, options);
    };
    var qaItems = [
        //No.01
        {
            question: {
                title: t("AREAS.QA.CONTENTS.QUESTION.TITLE_0"),
                description: getQuestionDescription("AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_0", "AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_WITH_AREA_0"),
                isOpen: false
            },
            answer: {
                title: t("AREAS.QA.CONTENTS.ANSWER.TITLE_0"),
                description: t("AREAS.QA.CONTENTS.ANSWER.DESCRIPTION_0")
            }
        },
        //No.02
        {
            question: {
                title: t("AREAS.QA.CONTENTS.QUESTION.TITLE_1"),
                description: getQuestionDescription("AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_1", "AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_WITH_AREA_1", {
                    locationName: locationName
                }),
                isOpen: false
            },
            answer: {
                title: t("AREAS.QA.CONTENTS.ANSWER.TITLE_1"),
                description: t("AREAS.QA.CONTENTS.ANSWER.DESCRIPTION_1")
            }
        },
        //No.03
        {
            question: {
                title: t("AREAS.QA.CONTENTS.QUESTION.TITLE_2"),
                description: getQuestionDescription("AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_2", "AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_WITH_AREA_2", {
                    locationName: locationName
                }),
                isOpen: false
            },
            answer: {
                title: t("AREAS.QA.CONTENTS.ANSWER.TITLE_2"),
                description: t("AREAS.QA.CONTENTS.ANSWER.DESCRIPTION_2", {
                    locationName: locationName
                })
            }
        },
        //No.04
        {
            question: {
                title: t("AREAS.QA.CONTENTS.QUESTION.TITLE_3"),
                description: getQuestionDescription("AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_3", "AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_WITH_AREA_3"),
                isOpen: false
            },
            answer: {
                title: t("AREAS.QA.CONTENTS.ANSWER.TITLE_3"),
                description: t("AREAS.QA.CONTENTS.ANSWER.DESCRIPTION_3")
            }
        },
        //No.05
        {
            question: {
                title: t("AREAS.QA.CONTENTS.QUESTION.TITLE_4"),
                description: getQuestionDescription("AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_4", "AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_WITH_AREA_4"),
                isOpen: false
            },
            answer: {
                title: t("AREAS.QA.CONTENTS.ANSWER.TITLE_4"),
                description: t("AREAS.QA.CONTENTS.ANSWER.DESCRIPTION_4")
            }
        },
        //No.06
        {
            question: {
                title: t("AREAS.QA.CONTENTS.QUESTION.TITLE_5"),
                description: getQuestionDescription("AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_5", "AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_WITH_AREA_5"),
                isOpen: false
            },
            answer: {
                title: t("AREAS.QA.CONTENTS.ANSWER.TITLE_5"),
                description: t("AREAS.QA.CONTENTS.ANSWER.DESCRIPTION_5")
            }
        },
        //No.07
        {
            question: {
                title: t("AREAS.QA.CONTENTS.QUESTION.TITLE_6"),
                description: getQuestionDescription("AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_6", "AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_6_WITH_AREA", {
                    locationName: locationName
                }),
                isOpen: false
            },
            answer: {
                title: t("AREAS.QA.CONTENTS.ANSWER.TITLE_6"),
                description: t("AREAS.QA.CONTENTS.ANSWER.DESCRIPTION_6", {
                    locationName: locationName
                })
            }
        },
        //No.08
        {
            question: {
                title: t("AREAS.QA.CONTENTS.QUESTION.TITLE_7", {
                    locationName: locationName
                }),
                description: getQuestionDescription("AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_7", "AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_7_WITH_AREA", {
                    locationName: locationName
                }),
                isOpen: false,
                isDisplay: !ignoreIds.includes(id)
            },
            answer: {
                title: t("AREAS.QA.CONTENTS.ANSWER.TITLE_7"),
                description: t("AREAS.QA.CONTENTS.ANSWER.DESCRIPTION_7", {
                    locationName: locationName
                })
            }
        },
        //No.09
        {
            question: {
                title: t("AREAS.QA.CONTENTS.QUESTION.TITLE_8"),
                description: getQuestionDescription("AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_8", "AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_8_WITH_AREA", {
                    locationName: locationName
                }),
                isOpen: false,
                isDisplay: !ignoreIds.includes(id)
            },
            answer: {
                title: t("AREAS.QA.CONTENTS.ANSWER.TITLE_8"),
                description: t("AREAS.QA.CONTENTS.ANSWER.DESCRIPTION_8", {
                    locationName: locationName
                })
            }
        },
        //No.10
        {
            question: {
                title: t("AREAS.QA.CONTENTS.QUESTION.TITLE_9"),
                description: getQuestionDescription("AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_9", "AREAS.QA.CONTENTS.QUESTION.DESCRIPTION_9_WITH_AREA", {
                    locationName: locationName
                }),
                isOpen: false
            },
            answer: {
                title: t("AREAS.QA.CONTENTS.ANSWER.TITLE_9"),
                description: t("AREAS.QA.CONTENTS.ANSWER.DESCRIPTION_9")
            }
        }, 
    ];
    var ref = (0,react.useState)(qaItems), qaList = ref[0], setQaList = ref[1];
    var _onClickAccordion = (0,react.useCallback)(function(index) {
        var updatedList = (0,_to_consumable_array/* default */.Z)(qaList);
        updatedList[index].question.isOpen = !updatedList[index].question.isOpen;
        setQaList(updatedList);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (Qa_module_default()).qa,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (Qa_module_default()).qaList,
            children: qaList.map(function(qa, index) {
                if (qa.question.isDisplay === false) {
                    return null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: (Qa_module_default()).qaListItem,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Qa_module_default()).qaListItemQuestion,
                            onClick: function() {
                                return _onClickAccordion(index);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Qa_module_default()).qaListItemContent,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Qa_module_default()).qaListItemContentTitle,
                                        children: qa.question.description
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Qa_module_default()).qaListItemQuestionTrigger,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionIconComponent/* default */.Z, {
                                        isOpenAccordion: qa.question.isOpen,
                                        accordionStyle: (Qa_module_default()).accordionIcon
                                    })
                                })
                            ]
                        }),
                        qa.question.isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Qa_module_default()).qaListItemAnswer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Qa_module_default()).qaListItemContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Qa_module_default()).qaListItemContentTitle,
                                        children: qa.answer.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Qa_module_default()).qaListItemContentDesc,
                                        children: qa.answer.description.split(/(https?:\/\/[\w!\?/\+\-_~=;\.,\*&@#\$%\(\)'\[\]]+)/).map(function(v, i) {
                                            return i & 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: v,
                                                passHref: true,
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    className: (Qa_module_default()).link,
                                                    children: v
                                                })
                                            }, i) : v;
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ var spaces_Qa = (Qa);

// EXTERNAL MODULE: ./src/components/stores/CardStore.module.scss
var CardStore_module = __webpack_require__(30540);
var CardStore_module_default = /*#__PURE__*/__webpack_require__.n(CardStore_module);
// EXTERNAL MODULE: ./src/components/buttons/AppStoreButtonComponent.tsx
var AppStoreButtonComponent = __webpack_require__(32468);
// EXTERNAL MODULE: ./src/components/buttons/GooglePlayButtonComponent.tsx
var GooglePlayButtonComponent = __webpack_require__(2168);
;// CONCATENATED MODULE: ./src/components/stores/CardStore.tsx



//component


var CardStore = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CardStore_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CardStore_module_default()).cardInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CardStore_module_default()).cardTitle,
                        children: t("AREAS.APP.DOWNLOAD_COMFORTABLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CardStore_module_default()).cardBanner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStoreButtonComponent/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GooglePlayButtonComponent/* default */.Z, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (CardStore_module_default()).cardImage,
                    src: "/app_main_visual.webp",
                    alt: t("META.APP_MAIN_VISUAL")
                })
            })
        ]
    });
};
/* harmony default export */ var stores_CardStore = (CardStore);

// EXTERNAL MODULE: ./src/components/domains/country/city/slug/AccordionBlock.module.scss
var AccordionBlock_module = __webpack_require__(22165);
var AccordionBlock_module_default = /*#__PURE__*/__webpack_require__.n(AccordionBlock_module);
;// CONCATENATED MODULE: ./src/components/domains/country/city/slug/AccordionBlock.tsx


// components

// styles

function AccordionBlock(param) {
    var title = param.title, children = param.children;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
        className: (AccordionBlock_module_default()).block,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                className: (AccordionBlock_module_default()).blockTitle,
                onClick: function() {
                    setIsOpen(!isOpen);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (AccordionBlock_module_default()).blockTitleText,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (AccordionBlock_module_default()).blockTitleIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionIconComponent/* default */.Z, {
                            isOpenAccordion: isOpen,
                            accordionStyle: (AccordionBlock_module_default()).accordionIcon
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                className: "".concat((AccordionBlock_module_default()).blockContent, " ").concat(isOpen ? (AccordionBlock_module_default()).blockContentActive : ""),
                children: children
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/common/intercom.ts
var intercom = __webpack_require__(60966);
// EXTERNAL MODULE: ./src/pages/[country]/city/Slug.module.scss
var Slug_module = __webpack_require__(97281);
var Slug_module_default = /*#__PURE__*/__webpack_require__.n(Slug_module);
;// CONCATENATED MODULE: ./src/pages/[country]/city/[...slug].tsx









//lib














// hooks




//component















//style


var SELECTED_TAB_KEY = {
    space: "space",
    coinLocker: "coinLocker"
};
var ITEM_COUNT = 20;
// https://ecbo.slack.com/archives/CD7P2G9KL/p1763552066856849?thread_ts=1762323946.583289&cid=CD7P2G9KL
var EXCEPTION_LOCATION_IDS = [
    84,
    77
] // 84: よみうりランド, 77: 東京ドーム
;
var CitySlugPage = function(props) {
    (0,useAffiliateTracking/* useAffiliateTracking */.H)();
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath, localePath = router.locale, query = router.query;
    var t = (0,esm/* useTranslation */.$G)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    // Loading
    var ref = (0,react.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    // 施設情報 (駅 or 施設)
    var ref1 = (0,useStations/* useStations */.Q)(), stations = ref1.stations, fetchStations = ref1.fetchStations;
    var ref2 = (0,useFacilities/* useFacilities */.o)(), groupedFacilities = ref2.groupedFacilities, fetchFacilities = ref2.fetchFacilities;
    var ref3 = (0,react.useState)(null), thisPrefecture = ref3[0], setThisPrefecture = ref3[1];
    //パンクズリスト
    var ref4 = (0,react.useState)([]), breadcrumbMenus = ref4[0], setBreadcrumbMenus = ref4[1];
    //メインビジュアル
    var ref5 = (0,react.useState)({
        backgroundImage: null
    }), mainVisualSectionStyle = ref5[0], setMainVisualSectionStyle = ref5[1];
    // タブ切り替え
    var ref6 = (0,react.useState)(SELECTED_TAB_KEY.space), spaceCoinLockerTabKey = ref6[0], setSpaceCoinLockerTabKey = ref6[1];
    //おすすめ預かり場所
    var ref7 = (0,react.useState)(null), recommendedFilter = ref7[0], setRecommendedFilter = ref7[1];
    var isResettingRecommendedFilterPageRef = (0,react.useRef)(false);
    var ref8 = (0,react.useState)(true), isInitialLoad = ref8[0], setIsInitialLoad = ref8[1];
    var ref9 = useAreaLockers(), lockers = ref9.lockers, getAreaLockers = ref9.getAreaLockers;
    var ref10 = useLegacyCoinLockers(), legacyCoinLockers = ref10.legacyCoinLockers, fetchLegacyCoinLockers = ref10.fetchLegacyCoinLockers;
    // URLパラメータからページ番号を取得
    var currentPage = (0,react.useMemo)(function() {
        var pageParam = query.page;
        var page = pageParam ? parseInt(pageParam, 10) : 1;
        return page > 0 ? page : 1;
    }, [
        query.page
    ]);
    var recommendedFilterOptions = (0,react.useMemo)(function() {
        return [
            {
                key: "today",
                label: t("AREAS.CITY.SLUG.RECOMMENDED_FILTER_TODAY_BUTTON")
            },
            {
                key: "tomorrow",
                label: t("AREAS.CITY.SLUG.RECOMMENDED_FILTER_TOMORROW_BUTTON")
            },
            {
                key: "open24Hours",
                label: t("AREAS.CITY.SLUG.RECOMMENDED_FILTER_OPEN_24_HOURS_BUTTON")
            }, 
        ];
    }, [
        t
    ]);
    var locationDetail = props.locationDetail;
    var ref11 = useNearbySpaces(), nearbySpaces = ref11.spaces, nearbyTotalCount = ref11.totalCount, isNearbySpacesLoading = ref11.isLoading, loadNearbySpaces = ref11.loadNearbySpaces;
    var shouldUseWithAreaTranslation = EXCEPTION_LOCATION_IDS.includes(locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.id);
    var recommendedSpacesTotalCount = nearbyTotalCount;
    // Restore scroll on browser back/forward after recommended spaces have loaded.
    (0,useScrollPositionRestoration/* default */.Z)(!!recommendedSpacesTotalCount);
    // コインロッカー
    var locationCoinLockers = (0,es/* useSelector */.v9)(function(state) {
        return getLocationCoinLockers(state);
    });
    // 今年の年度
    var thisYear = dayjs_min_default()().year();
    /**
   * URIのパラメーターを整理する
   * @returns
   */ var uriParams = (0,react.useMemo)(function() {
        // クエリパラメータを除外してパスのみを取得
        var pathOnly = asPath.split("?")[0];
        var path = pathOnly.split("/");
        var uriList = path.slice(1);
        if (uriList.length === 3) {
            //都道府県
            return {
                isCity: true,
                countryCode: uriList[0],
                citySlug: uriList.pop()
            };
        } else {
            //駅 or 施設
            return {
                isCity: false,
                countryCode: uriList[0],
                citySlug: uriList[2],
                id: uriList.pop()
            };
        }
    }, [
        asPath
    ]);
    var prefectures = (0,usePrefectures/* usePrefectures */.w)({
        countryId: (0,constants/* getPrefectureCountryId */.cp)(uriParams.countryCode),
        enabled: uriParams.countryCode === "jpn" || uriParams.countryCode === "twn"
    }).prefectures;
    var facilityRecommendationConfig = (0,react.useMemo)(function() {
        var ref;
        if (!locationDetail) {
            return null;
        }
        var isTaiwan = uriParams.countryCode === "twn";
        var taiwanPrefectureId = isTaiwan ? findPrefectureIdBySlug(prefectures, uriParams.citySlug) : undefined;
        if (uriParams.isCity) {
            var legacyId = locationDetail.id;
            var prefectureId = isTaiwan ? taiwanPrefectureId !== null && taiwanPrefectureId !== void 0 ? taiwanPrefectureId : legacyId : legacyId;
            if (prefectureId == null) return null;
            return {
                type: "city",
                prefectureId: prefectureId
            };
        }
        if (((ref = locationDetail.location_type) === null || ref === void 0 ? void 0 : ref.name) === "station") {
            var legacyId1 = locationDetail.region.id;
            var prefectureId1 = isTaiwan ? taiwanPrefectureId !== null && taiwanPrefectureId !== void 0 ? taiwanPrefectureId : legacyId1 : legacyId1;
            if (prefectureId1 == null) return null;
            return {
                type: "station",
                prefectureId: prefectureId1
            };
        }
        return null;
    }, [
        locationDetail,
        uriParams.isCity,
        uriParams.countryCode,
        uriParams.citySlug,
        prefectures
    ]);
    var metaTitle = (0,react.useMemo)(function() {
        var titleParameters = {
            year: thisYear,
            location: props.name
        };
        if (currentPage > 1) {
            // ページ番号付きのタイトルを試し、存在しない場合はデフォルトにページ番号を追加
            return t(shouldUseWithAreaTranslation ? "META.TITLE.CITY.SLUG_YEAR_LOCATION_PAGE_WITH_AREA" : "META.TITLE.CITY.SLUG_YEAR_LOCATION_PAGE", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, titleParameters), {
                currentPage: currentPage,
                totalPage: Math.ceil(recommendedSpacesTotalCount / ITEM_COUNT)
            }));
        }
        return t(shouldUseWithAreaTranslation ? "META.TITLE.CITY.SLUG_YEAR_LOCATION_WITH_AREA" : "META.TITLE.CITY.SLUG_YEAR_LOCATION", titleParameters);
    }, [
        t,
        thisYear,
        props.name,
        currentPage,
        recommendedSpacesTotalCount,
        shouldUseWithAreaTranslation, 
    ]);
    var metaDescription = (0,react.useMemo)(function() {
        if (currentPage > 1) {
            // ページ番号付きのdescriptionを試し、存在しない場合はデフォルトにページ番号を追加
            var pageDescription = t("META.DESCRIPTION.CITY.SLUG_PAGE", {
                location: props.name,
                page: currentPage,
                currentPage: currentPage,
                totalPage: Math.ceil(recommendedSpacesTotalCount / ITEM_COUNT)
            });
            return pageDescription;
        }
        return t("META.DESCRIPTION.CITY.SLUG", {
            location: props.name
        });
    }, [
        t,
        props.name,
        currentPage,
        recommendedSpacesTotalCount
    ]);
    /**
   * エリア詳細を取得する
   * @returns
   */ var getLocationData = function() {
        if (uriParams.isCity) {
            return getInfoByLocale(props.locale, {
                ja: {
                    prefecture_name: locationDetail.name,
                    location_name: locationDetail.name
                },
                en: {
                    prefecture_name: locationDetail.en_name,
                    location_name: locationDetail.en_name
                }
            });
        } else {
            var ref, ref1;
            return getInfoByLocale(props.locale, {
                ja: {
                    prefecture_name: (ref = locationDetail.region) === null || ref === void 0 ? void 0 : ref.name,
                    location_name: locationDetail.name
                },
                en: {
                    prefecture_name: (ref1 = locationDetail.region) === null || ref1 === void 0 ? void 0 : ref1.en_name,
                    location_name: locationDetail.en_name
                }
            });
        }
    };
    /**
   * 初期化処理
   * パンクズリスト
   */ var initBreadcrumbMenus = function() {
        var menus = getGetBreadcrumbMenus();
        setBreadcrumbMenus(menus);
    };
    /**
   * パンクズリストを取得する
   * @returns
   */ var getGetBreadcrumbMenus = function() {
        var menus = [];
        var basePath = "/".concat(props.locale, "/").concat(uriParams.countryCode, "/city");
        basePath = basePath.replace("zh_tw", "zh-TW");
        //city
        var menu1 = {
            label: uriParams.isCity ? t("AREAS.CITY.SLUG.BREADCRUMB", {
                location: getLocationData().prefecture_name
            }) : getLocationData().prefecture_name,
            path: "".concat(basePath, "/").concat(uriParams.citySlug)
        };
        menus.push(menu1);
        if (!uriParams.isCity) {
            //駅 or 施設
            var menu2 = {
                label: t("AREAS.CITY.SLUG.BREADCRUMB", {
                    location: props.name
                })
            };
            menus.push(menu2);
        }
        return menus;
    };
    var openIntercomMessage = (0,intercom/* useCustomIntercom */.j)().openIntercomMessage;
    /**
   * シェア文言を取得する
   * @returns string
   */ var getShareText = function() {
        var text = "";
        switch(localePath){
            case "ja":
                text = "".concat(props.name, "でおすすめ荷物預かり場所とコインロッカー情報 - 荷物預けるなら ecbo cloak（エクボクローク）");
                break;
            case "en":
                text = "Recommended Luggage Storage Locations and Coin Locker Information at ".concat(props.name, " - If you want to leave your luggage, ecbo cloak");
                break;
            case "zh-TW":
                text = "".concat(props.name, "的推薦行李寄存地點和投幣式儲物櫃信息 - 如果你想寄存行李, ecbo cloak");
                break;
        }
        return text;
    };
    /**
   * 最終更新日のテキストを取得
   * @returns
   */ var getLastUpdateText = function() {
        var text = "";
        // let date: string = dayjs(locationDetail.updated_at).format('YYYY/M/d')
        var date = dayjs_min_default()().format("YYYY/M/D");
        // if (!locationDetail.updated_at) {
        //   return text
        // }
        switch(localePath){
            case "ja":
                // date = dayjs(locationDetail.updated_at).format('YYYY年M月d日')
                date = dayjs_min_default()().format("YYYY年M月D日");
                text = "最終更新日：".concat(date);
                break;
            case "en":
                text = "Last update：".concat(date);
                break;
            case "zh-TW":
                text = "最近更新時間：".concat(date);
                break;
        }
        return text;
    };
    /**
   * コインロッカーMapのピンをクリックしたら、該当セクションまでスクロール処理
   * @param {number} id コインロッカーID
   * @param {boolean} isOld 旧コインロッカーかどうか
   */ var scrollToRecommendedCoinLockerSection = function(id) {
        var isOld = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        // Create ID based on whether it's an old coin locker or regular one
        var sectionId = isOld ? "recommended-coin-locker-card-old-".concat(id) : "recommended-coin-locker-card-".concat(id);
        var element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
    /**
   * ShareするURLを取得する
   * @returns
   */ var createShareUrl = function() {
        var url = "".concat("https://stg-cloak.ecbo.io", "/").concat(localePath).concat(asPath);
        // ハッシュタグがある場合は取り除く
        if (url.indexOf("#")) {
            url = url.split("#")[0];
        }
        return url;
    };
    /**
   * Wiki Sectionの表示管理
   * 言語とデータの存在チェックする
   * @returns
   */ var isShowWikiSection = function() {
        return localePath === "ja" && !!locationDetail.wiki;
    };
    /**
   * ページトップにスクロールする
   */ var moveScrollTop = function() {
        var pos = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
        if (pos > 0) {
            document.querySelector("body").scrollTo(0, 0);
        }
    };
    /**
   * ページ変更時の処理
   */ var handlePageChange = (0,react.useCallback)(function(page) {
        if (page === currentPage) {
            return;
        }
        var newQuery = (0,_object_spread/* default */.Z)({}, router.query);
        if (page === 1) {
            // ページ1の場合はpageパラメータを削除
            delete newQuery.page;
        } else {
            // ページ2以降はpageパラメータを設定
            newQuery.page = page.toString();
        }
        // 繁体字の場合、zh_twをzh-TWに変換
        var locale = props.locale.replace("zh_tw", "zh-TW");
        // クエリパラメータを更新
        router.push({
            pathname: "/".concat(locale).concat(router.pathname),
            query: newQuery
        }, undefined, {
            shallow: true
        });
    }, [
        currentPage,
        router
    ]);
    var handleRecommendedFilterChange = (0,react.useCallback)(function(condition) {
        var nextFilter = recommendedFilter === condition ? null : condition;
        if (currentPage !== 1) {
            isResettingRecommendedFilterPageRef.current = true;
            handlePageChange(1);
        }
        switch(condition){
            case "today":
                (0,gtag/* sendGtmEvent */.T5)({
                    eventName: gtag/* GTM_EVENT_CLICK_FILTER_TODAY */.Ed
                });
                break;
            case "tomorrow":
                (0,gtag/* sendGtmEvent */.T5)({
                    eventName: gtag/* GTM_EVENT_CLICK_FILTER_TOMORROW */.cV
                });
                break;
            case "open24Hours":
                (0,gtag/* sendGtmEvent */.T5)({
                    eventName: gtag/* GTM_EVENT_CLICK_FILTER_OPEN_24_HOURS */.ae
                });
                break;
        }
        setRecommendedFilter(nextFilter);
    }, [
        recommendedFilter,
        currentPage,
        handlePageChange
    ]);
    //初期化処理
    (0,react.useEffect)(function() {
        openIntercomMessage();
        //API
        if (uriParams.isCity) {
            dispatch((0,actions/* fetchLocationDetailRequest */.Ks)(uriParams.citySlug, "city", uriParams.countryCode));
        } else {
            dispatch((0,actions/* fetchLocationDetailRequest */.Ks)(uriParams.id, "location", uriParams.countryCode, uriParams.citySlug));
        }
        // スクロールトップ
        moveScrollTop();
    }, [
        uriParams.isCity,
        uriParams.citySlug,
        uriParams.countryCode,
        uriParams.id
    ]);
    (0,react.useEffect)(function() {
        setIsLoading(false);
        setIsInitialLoad(false);
    }, [
        dispatch
    ]);
    // パスが変更時にスクロールトップ
    (0,react.useEffect)(function() {
        moveScrollTop();
        // パスが変更された場合は初回ロードフラグをリセット
        setIsInitialLoad(true);
    }, [
        asPath
    ]);
    //場所詳細が変更時
    (0,react.useEffect)(function() {
        var ref;
        if (!locationDetail) return;
        initBreadcrumbMenus();
        var acceptLanguage = (0,getAcceptLanguageByLocale/* default */.Z)(props.locale);
        //メインビジュアル
        setMainVisualSectionStyle({
            backgroundImage: !!locationDetail.image_url ? "url(".concat(locationDetail.image_url, ")") : null
        });
        if (isResettingRecommendedFilterPageRef.current && currentPage !== 1) {
            return;
        }
        // URLのpageパラメータをリセット（ページ1に戻す）
        // ただし、初回ロード時（直接アクセス時）は除く
        if (router.query.page && !isInitialLoad) {
            var newQuery = (0,_object_spread/* default */.Z)({}, router.query);
            delete newQuery.page;
            router.push({
                pathname: router.pathname,
                query: newQuery
            }, undefined, {
                shallow: true
            });
        }
        // 都道府県をセットする
        setThisPrefecture({
            id: uriParams.isCity ? locationDetail.id : (ref = locationDetail.region) === null || ref === void 0 ? void 0 : ref.id,
            slug: uriParams.citySlug,
            name: locationDetail.name,
            lat: Number(locationDetail.latitude),
            lon: Number(locationDetail.longitude),
            en_name: locationDetail.en_name,
            en_area_name: "",
            zh_cn_name: locationDetail.zh_cn_name,
            zh_cn_area_name: "",
            zh_tw_name: locationDetail.zh_tw_name,
            zh_tw_area_name: "",
            zoom_pc: 0,
            zoom_sp: 0
        });
        loadNearbySpaces(buildNearbySpacesParams({
            locationDetail: locationDetail,
            isCity: uriParams.isCity,
            page: currentPage,
            pageSize: ITEM_COUNT,
            locale: props.locale,
            filterCondition: recommendedFilter
        }));
        dispatch((0,actions/* fetchLocationCoinLockersRequest */.wI)(locationDetail.latitude, locationDetail.longitude, acceptLanguage));
        fetchLegacyCoinLockers({
            latitude: locationDetail.latitude,
            longitude: locationDetail.longitude
        });
        if (isResettingRecommendedFilterPageRef.current && currentPage === 1) {
            isResettingRecommendedFilterPageRef.current = false;
        }
        getAreaLockers({
            latitude: locationDetail.latitude,
            longitude: locationDetail.longitude
        });
    }, [
        locationDetail,
        currentPage,
        recommendedFilter,
        uriParams.isCity,
        props.locale,
        loadNearbySpaces,
        fetchLegacyCoinLockers, 
    ]);
    var displayRecommendedSpaces = (0,react.useMemo)(function() {
        return nearbySpaces.map(mapNearbySpaceToRecommendedSpace);
    }, [
        nearbySpaces
    ]);
    var displayRecommendedSpacesLoading = isNearbySpacesLoading;
    // 都道府県が変更されたら、施設データを取得する
    (0,react.useEffect)(function() {
        if (!(thisPrefecture === null || thisPrefecture === void 0 ? void 0 : thisPrefecture.id)) {
            return;
        }
        fetchStations(thisPrefecture.id);
        fetchFacilities(thisPrefecture.id, {
            type: "facility"
        });
    }, [
        thisPrefecture === null || thisPrefecture === void 0 ? void 0 : thisPrefecture.id,
        fetchStations,
        fetchFacilities
    ]);
    /**
   * コピーする
   * @returns
   */ var handleShareClick = function() {
        if (!navigator.clipboard) {
            return;
        }
        var url = createShareUrl();
        var text = getShareText();
        var shareText = "".concat(text, " ").concat(url);
        navigator.clipboard.writeText(shareText).then(function() {
            alert("copied");
        });
    };
    var ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                    title: metaTitle,
                    description: metaDescription,
                    url: "/".concat(props.locale === "default" ? "ja" : props.locale).concat(asPath),
                    image: props.shareImageUrl
                }),
                isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComponent/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "".concat((Slug_module_default()).mainVisualSection, " ").concat(!mainVisualSectionStyle.backgroundImage && (Slug_module_default()).mainVisualSectionNoneBg),
                            style: mainVisualSectionStyle,
                            children: [
                                !!mainVisualSectionStyle.backgroundImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (Slug_module_default()).pseudoElement
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (Slug_module_default()).mainVisualSectionShare,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (Slug_module_default()).mainVisualSectionShareButton,
                                        onClick: handleShareClick,
                                        type: "button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (Slug_module_default()).mainVisualSectionShareButtonImage,
                                            src: "/share_icon_white.svg",
                                            alt: "",
                                            width: "27",
                                            height: "27"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: (Slug_module_default()).mainVisualSectionTitle,
                                    children: t(shouldUseWithAreaTranslation ? "AREAS.CITY.SLUG.MAIN_SPACE_TITLE_YEAR_LOCATION_WITH_AREA" : "AREAS.CITY.SLUG.MAIN_SPACE_TITLE_YEAR_LOCATION", {
                                        year: thisYear,
                                        location: props.name
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "".concat((Slug_module_default()).searchSection, " ").concat(!mainVisualSectionStyle.backgroundImage && (Slug_module_default()).searchSectionNoneBg),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Slug_module_default()).sectionContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slug_SearchForm, {
                                    name: props.name,
                                    latitude: locationDetail.latitude,
                                    longitude: locationDetail.longitude
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: (Slug_module_default()).updatedAtSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Slug_module_default()).updatedAtText,
                                children: getLastUpdateText()
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: (Slug_module_default()).tabSection,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Slug_module_default()).tabMenus,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "".concat((Slug_module_default()).tabMenu, " ").concat(spaceCoinLockerTabKey === SELECTED_TAB_KEY.space ? (Slug_module_default()).tabMenuActive : ""),
                                            onClick: function() {
                                                setSpaceCoinLockerTabKey(SELECTED_TAB_KEY.space);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (Slug_module_default()).tabMenuIcon,
                                                    children: spaceCoinLockerTabKey === SELECTED_TAB_KEY.space ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: (Slug_module_default()).tabMenuIconImage,
                                                        src: "/suitcase_icon_blue.svg",
                                                        alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: (Slug_module_default()).tabMenuIconImage,
                                                        src: "/suitcase_icon_gray.svg",
                                                        alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (Slug_module_default()).tabMenuTitle,
                                                    children: [
                                                        t("COMMON.LUGGAGE_STORAGE_PLACES"),
                                                        "（",
                                                        recommendedSpacesTotalCount,
                                                        "）"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "".concat((Slug_module_default()).tabMenu, " ").concat(spaceCoinLockerTabKey === SELECTED_TAB_KEY.coinLocker ? (Slug_module_default()).tabMenuActive : ""),
                                            onClick: function() {
                                                setSpaceCoinLockerTabKey(SELECTED_TAB_KEY.coinLocker);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (Slug_module_default()).tabMenuIcon,
                                                    children: spaceCoinLockerTabKey === SELECTED_TAB_KEY.coinLocker ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: (Slug_module_default()).tabMenuIconImage,
                                                        src: "/coin_locker_icon_blue.svg",
                                                        alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: (Slug_module_default()).tabMenuIconImage,
                                                        src: "/coin_locker_icon_gray.svg",
                                                        alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (Slug_module_default()).tabMenuTitle,
                                                    children: [
                                                        t("COMMON.COIN_LOCKER.NAME"),
                                                        "（",
                                                        lockers.length + legacyCoinLockers.length,
                                                        "）"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Slug_module_default()).tabContents,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((Slug_module_default()).tabContent, " ").concat(spaceCoinLockerTabKey === SELECTED_TAB_KEY.space ? (Slug_module_default()).tabContentActive : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                                className: (Slug_module_default()).recommendedSection,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Slug_module_default()).sectionContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(titles_SectionBottomBorderTitle, {
                                                            text: t("AREAS.CITY.SLUG.RECOMMENDED_SELECT_TITLE", {
                                                                location: props.name
                                                            }),
                                                            subTextElement: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Slug_module_default()).recommendedSectionSectionTitleSubElement,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: (Slug_module_default()).recommendedSectionSectionTitleSubElementImage,
                                                                        src: "/map_pin_icon_gray.svg",
                                                                        alt: ""
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (Slug_module_default()).recommendedSectionSectionTitleSubElementText,
                                                                        children: t("COMMON.TOTAL_SPACE", {
                                                                            total: recommendedSpacesTotalCount
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (Slug_module_default()).recommendedSectionFilters,
                                                            children: recommendedFilterOptions.map(function(option) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: function() {
                                                                        return handleRecommendedFilterChange(option.key);
                                                                    },
                                                                    className: "".concat((Slug_module_default()).recommendedSectionFilterButton, " ").concat(recommendedFilter === option.key ? (Slug_module_default()).recommendedSectionFilterButtonActive : ""),
                                                                    "aria-pressed": recommendedFilter === option.key,
                                                                    children: option.label
                                                                }, option.key);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_RecommendedSpaceCardList, {
                                                            list: displayRecommendedSpaces,
                                                            totalCount: recommendedSpacesTotalCount,
                                                            currentPage: currentPage,
                                                            locale: props.locale,
                                                            itemsPerPage: ITEM_COUNT,
                                                            onPageChange: handlePageChange,
                                                            isLoading: displayRecommendedSpacesLoading,
                                                            usePagination: !displayRecommendedSpacesLoading
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((Slug_module_default()).tabContent, " ").concat(spaceCoinLockerTabKey === SELECTED_TAB_KEY.coinLocker ? (Slug_module_default()).tabContentActive : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                                id: "coin-locker-section",
                                                className: "".concat((Slug_module_default()).recommendedSection),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Slug_module_default()).sectionContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(titles_SectionBottomBorderTitle, {
                                                            text: t("AREAS.CITY.SLUG.RECOMMENDED_COIN_LOCKER_SELECT_TITLE", {
                                                                location: props.name,
                                                                count: lockers.length + legacyCoinLockers.length
                                                            }),
                                                            subTextElement: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Slug_module_default()).recommendedSectionSectionTitleSubElement,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: (Slug_module_default()).recommendedSectionSectionTitleSubElementImage,
                                                                        src: "/map_pin_icon_gray.svg",
                                                                        alt: ""
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (Slug_module_default()).recommendedSectionSectionTitleSubElementText,
                                                                        children: t("COMMON.TOTAL_COIN_LOCKER", {
                                                                            total: lockers.length + legacyCoinLockers.length
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        ((lockers === null || lockers === void 0 ? void 0 : lockers.length) > 0 || (legacyCoinLockers === null || legacyCoinLockers === void 0 ? void 0 : legacyCoinLockers.length) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(slug_CoinLockerMapSection, {
                                                            centerLat: Number(locationDetail.latitude),
                                                            centerLon: Number(locationDetail.longitude),
                                                            coinLockers: lockers,
                                                            oldCoinLockers: legacyCoinLockers,
                                                            scrollToRecommendedCoinLockerSection: scrollToRecommendedCoinLockerSection
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_RecommendedCoinLockerCardList, {
                                                            lockers: lockers,
                                                            oldList: legacyCoinLockers,
                                                            locale: props.locale
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        displayRecommendedSpaces.length === 0 && locationCoinLockers.length === 0 && facilityRecommendationConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)(facility_FacilityRecommendationsSection, {
                            latitude: locationDetail.latitude,
                            longitude: locationDetail.longitude,
                            type: facilityRecommendationConfig.type,
                            prefectureId: facilityRecommendationConfig.prefectureId,
                            locationName: props.name,
                            countrySlug: uriParams.countryCode,
                            citySlug: uriParams.citySlug,
                            localePath: localePath,
                            locale: props.locale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: (Slug_module_default()).aboutServiceSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Slug_module_default()).sectionContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        className: (Slug_module_default()).aboutServiceSectionTitle,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (Slug_module_default()).aboutServiceSectionTitleImage,
                                                src: "/logo.webp",
                                                alt: "ecbo cloak",
                                                width: "138"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                className: (Slug_module_default()).aboutServiceSectionTitleText,
                                                children: t("AREAS.CITY.SLUG.USE_SERVICE_TITLE")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (Slug_module_default()).aboutServiceSectionFeature,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: (Slug_module_default()).aboutServiceSectionFeatureItem,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: (Slug_module_default()).aboutServiceSectionFeatureItemImage,
                                                        src: "/feature_01_02.webp",
                                                        alt: "",
                                                        width: "135"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (Slug_module_default()).aboutServiceSectionFeatureItemText,
                                                        children: t("AREAS.CITY.SLUG.FEATURE_MORE_PLACE_TITLE")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: (Slug_module_default()).aboutServiceSectionFeatureItem,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: (Slug_module_default()).aboutServiceSectionFeatureItemImage,
                                                        src: "/feature_02_02.webp",
                                                        alt: "",
                                                        width: "135"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (Slug_module_default()).aboutServiceSectionFeatureItemText,
                                                        children: t("AREAS.CITY.SLUG.FEATURE_LEAVE_COIN_LOCKER_TITLE")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: (Slug_module_default()).aboutServiceSectionFeatureItem,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: (Slug_module_default()).aboutServiceSectionFeatureItemImage,
                                                        src: "/feature_03_02.webp",
                                                        alt: "",
                                                        width: "135"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (Slug_module_default()).aboutServiceSectionFeatureItemText,
                                                        children: t("AREAS.CITY.SLUG.FEATURE_SIZE_TITLE")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionBlock, {
                                        title: t("AREAS.CITY.SLUG.CHECK_HOW_TO_USE"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Slug_module_default()).howToUseSection,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: (Slug_module_default()).howToUseList,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (Slug_module_default()).howToUseListItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                            className: (Slug_module_default()).howToUseInfo,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: (Slug_module_default()).howToUseInfoVisual,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: (Slug_module_default()).howToUseInfoVisualImage,
                                                                        src: "/how_to_use_01.webp",
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    className: (Slug_module_default()).howToUseInfoTitle,
                                                                    children: t("AREAS.CITY.SLUG.HOW_TO_USE_RESERVE")
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (Slug_module_default()).howToUseListItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                            className: (Slug_module_default()).howToUseInfo,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: (Slug_module_default()).howToUseInfoVisual,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: (Slug_module_default()).howToUseInfoVisualImage,
                                                                        src: "/how_to_use_02.webp",
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    className: (Slug_module_default()).howToUseInfoTitle,
                                                                    children: t("AREAS.CITY.SLUG.HOW_TO_USE_CHECKIN")
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (Slug_module_default()).howToUseListItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                            className: (Slug_module_default()).howToUseInfo,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: (Slug_module_default()).howToUseInfoVisual,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: (Slug_module_default()).howToUseInfoVisualImage,
                                                                        src: "/how_to_use_03.webp",
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    className: (Slug_module_default()).howToUseInfoTitle,
                                                                    children: t("AREAS.CITY.SLUG.HOW_TO_USE_DAY")
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionBlock, {
                                        title: t("AREAS.CITY.SLUG.CHECK_FEATURE_TITLE"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Slug_module_default()).featureSection,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: (Slug_module_default()).featureList,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (Slug_module_default()).featureListItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                            className: (Slug_module_default()).featureInfo,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: (Slug_module_default()).featureInfoIcon,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: (Slug_module_default()).featureInfoIconImage,
                                                                        src: "/feature_01.webp",
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    className: (Slug_module_default()).featureInfoTitle,
                                                                    children: t("AREAS.CITY.SLUG.FEATURE_PARTNERSHIP_TITLE")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: (Slug_module_default()).featureInfoDescription,
                                                                    children: t("AREAS.CITY.SLUG.FEATURE_PARTNERSHIP_DESCRIPTION")
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (Slug_module_default()).featureListItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                            className: (Slug_module_default()).featureInfo,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: (Slug_module_default()).featureInfoIcon,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: (Slug_module_default()).featureInfoIconImage,
                                                                        src: "/feature_02.webp",
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    className: (Slug_module_default()).featureInfoTitle,
                                                                    children: t("AREAS.CITY.SLUG.FEATURE_SPACE_TITLE")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: (Slug_module_default()).featureInfoDescription,
                                                                    children: t("AREAS.CITY.SLUG.FEATURE_SPACE_DESCRIPTION")
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (Slug_module_default()).featureListItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                            className: (Slug_module_default()).featureInfo,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: (Slug_module_default()).featureInfoIcon,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: (Slug_module_default()).featureInfoIconImage,
                                                                        src: "/feature_03.webp",
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    className: (Slug_module_default()).featureInfoTitle,
                                                                    children: t("AREAS.CITY.SLUG.FEATURE_SIZE_TITLE")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: (Slug_module_default()).featureInfoDescription,
                                                                    children: t("AREAS.CITY.SLUG.FEATURE_SIZE_DESCRIPTION")
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (Slug_module_default()).featureListItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                            className: (Slug_module_default()).featureInfo,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: (Slug_module_default()).featureInfoIcon,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: (Slug_module_default()).featureInfoIconImage,
                                                                        src: "/feature_04.webp",
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    className: (Slug_module_default()).featureInfoTitle,
                                                                    children: t("AREAS.CITY.SLUG.FEATURE_GUARANTEE_TITLE")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: (Slug_module_default()).featureInfoDescription,
                                                                    children: t("AREAS.CITY.SLUG.FEATURE_GUARANTEE_DESCRIPTION")
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionBlock, {
                                        title: t("AREAS.CITY.SLUG.CHECK_PLAN_TITLE"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Slug_module_default()).planSection,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: (Slug_module_default()).planList,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (Slug_module_default()).planListItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanCard, {
                                                            title: t("AREAS.CITY.SLUG.PLAN_BAG_SIZE"),
                                                            countryCode: uriParams.countryCode,
                                                            iconImage: "/plan_size_bag.webp",
                                                            sizeType: configs_space/* PRICE_SIZE_TYPE_BAG */.F$,
                                                            description: t("AREAS.CITY.SLUG.PLAN_BAG_DESCRIPTION")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (Slug_module_default()).planListItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanCard, {
                                                            title: t("AREAS.CITY.SLUG.PLAN_SUIT_SIZE"),
                                                            countryCode: uriParams.countryCode,
                                                            iconImage: "/plan_size_suitcase.webp",
                                                            sizeType: configs_space/* PRICE_SIZE_TYPE_SUITCASE */.TD,
                                                            description: t("AREAS.CITY.SLUG.PLAN_SUIT_DESCRIPTION")
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        uriParams.countryCode === "jpn" && !!props.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: (Slug_module_default()).qaSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Slug_module_default()).sectionContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(titles_SectionBottomBorderTitle, {
                                        text: t("AREAS.QA.TITLE")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spaces_Qa, {
                                        locationName: props.name,
                                        id: props.locationDetail.id,
                                        ignoreIds: EXCEPTION_LOCATION_IDS,
                                        useWithAreaTranslations: shouldUseWithAreaTranslation
                                    })
                                ]
                            })
                        }),
                        (displayRecommendedSpaces.length !== 0 || locationCoinLockers.length !== 0) && facilityRecommendationConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)(facility_FacilityRecommendationsSection, {
                            latitude: locationDetail.latitude,
                            longitude: locationDetail.longitude,
                            type: facilityRecommendationConfig.type,
                            prefectureId: facilityRecommendationConfig.prefectureId,
                            locationName: props.name,
                            countrySlug: uriParams.countryCode,
                            citySlug: uriParams.citySlug,
                            localePath: localePath,
                            locale: props.locale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: (Slug_module_default()).pageDescriptionSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Slug_module_default()).sectionContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(titles_SectionBottomBorderTitle, {
                                        text: t(shouldUseWithAreaTranslation ? "AREAS.CITY.SLUG.LOCATION_STORAGE_INFORMATION_WITH_AREA" : "AREAS.CITY.SLUG.LOCATION_STORAGE_INFORMATION", {
                                            location: props.name
                                        })
                                    }),
                                    spaceCoinLockerTabKey === SELECTED_TAB_KEY.space ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Slug_module_default()).pageDescriptionSectionText,
                                        children: t("AREAS.CITY.SLUG.MAIN_DESCRIPTION", {
                                            location: props.name
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Slug_module_default()).pageDescriptionSectionText,
                                        children: t("AREAS.CITY.SLUG.MAIN_DESCRIPTION_COIN_LOCKER", {
                                            location: props.name
                                        })
                                    })
                                ]
                            })
                        }),
                        isShowWikiSection() && !EXCEPTION_LOCATION_IDS.includes(props.locationDetail.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: (Slug_module_default()).wikiSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Slug_module_default()).sectionContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(titles_SectionBottomBorderTitle, {
                                        text: t(shouldUseWithAreaTranslation ? "AREAS.CITY.SLUG.WIKI_TITLE_WITH_AREA" : "AREAS.CITY.SLUG.WIKI_TITLE", {
                                            location: props.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Slug_module_default()).wikiSectionText,
                                        children: locationDetail.wiki
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: (Slug_module_default()).storeSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Slug_module_default()).sectionContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stores_CardStore, {})
                            })
                        }),
                        (locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.id) === 77 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Slug_module_default()).noticeSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Slug_module_default()).title,
                                children: t("AREAS.CITY.ANNOTATION")
                            })
                        }),
                        uriParams.countryCode === "jpn" && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: (Slug_module_default()).locationSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Slug_module_default()).sectionContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSection/* default */.Z, {
                                    locations: [],
                                    prefectures: prefectures !== null && prefectures !== void 0 ? prefectures : [],
                                    isSelectedArea: false,
                                    onSelectArea: undefined,
                                    setIsSelectedArea: function() {},
                                    stations: [],
                                    facilities: [],
                                    locale: props.locale,
                                    countryCode: uriParams.countryCode,
                                    isShowBackButton: false,
                                    isShowAreaName: false,
                                    sectionTitle: t("AREAS.CITY.SLUG.LOCATION_SECTION_TITLE_AREA"),
                                    areaPlaceListHeadingStyle: "h3",
                                    placeName: getLocationData().location_name
                                })
                            })
                        }),
                        uriParams.countryCode === "twn" && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: (Slug_module_default()).locationSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Slug_module_default()).sectionContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSection/* default */.Z, {
                                    locations: [],
                                    prefectures: prefectures !== null && prefectures !== void 0 ? prefectures : [],
                                    isSelectedArea: false,
                                    onSelectArea: undefined,
                                    setIsSelectedArea: function() {},
                                    stations: [],
                                    facilities: [],
                                    locale: props.locale,
                                    countryCode: uriParams.countryCode,
                                    isShowBackButton: false,
                                    isShowAreaName: false,
                                    sectionTitle: t("AREAS.CITY.SLUG.LOCATION_SECTION_TITLE_AREA"),
                                    areaPlaceListHeadingStyle: "h3",
                                    placeName: getLocationData().location_name
                                })
                            })
                        }),
                        uriParams.countryCode === "jpn" && thisPrefecture && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: (Slug_module_default()).locationSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Slug_module_default()).sectionContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSection/* default */.Z, {
                                    locations: [],
                                    isSelectedArea: true,
                                    onSelectArea: function() {},
                                    setIsSelectedArea: function() {},
                                    selectedPrefecture: thisPrefecture,
                                    stations: stations,
                                    facilities: (ref12 = groupedFacilities === null || groupedFacilities === void 0 ? void 0 : groupedFacilities.facilities) !== null && ref12 !== void 0 ? ref12 : [],
                                    locale: props.locale,
                                    countryCode: uriParams.countryCode,
                                    isShowBackButton: false,
                                    isShowAreaName: false,
                                    sectionTitle: t("AREAS.CITY.SLUG.LOCATION_SECTION_TITLE_PLACE_PREFECTURE", {
                                        place: getLocationData().location_name
                                    }),
                                    areaPlaceListHeadingStyle: "h3",
                                    placeName: getLocationData().location_name
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Slug_module_default()).sectionContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnerSection/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbLayout/* default */.Z, {
                            menus: breadcrumbMenus
                        })
                    ]
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (CitySlugPage);


/***/ }),

/***/ 60849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ calendarWeekHeader; }
/* harmony export */ });
/* unused harmony export generateTimeOptions */
var calendarWeekHeader = {
    Su: {
        en: "Sun",
        ja: "日",
        zh_tw: "日",
        "zh-TW": "日"
    },
    Mo: {
        en: "Mon",
        ja: "月",
        zh_tw: "一",
        "zh-TW": "日"
    },
    Tu: {
        en: "Tue",
        ja: "火",
        zh_tw: "二",
        "zh-TW": "二"
    },
    We: {
        en: "Wed",
        ja: "水",
        zh_tw: "三",
        "zh-TW": "三"
    },
    Th: {
        en: "Thu",
        ja: "木",
        zh_tw: "四",
        "zh-TW": "四"
    },
    Fr: {
        en: "Fri",
        ja: "金",
        zh_tw: "五",
        "zh-TW": "五"
    },
    Sa: {
        en: "Sat",
        ja: "土",
        zh_tw: "六",
        "zh-TW": "六"
    }
};
var generateTimeOptions = function() {
    var minHour = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, maxHour = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 24;
    var times = [];
    for(var hour = minHour; hour <= maxHour; hour++){
        for(var minute = 0; minute < 60; minute += 30){
            if (hour === maxHour && minute === 30) break;
            var formattedHour = hour.toString().padStart(2, "0");
            var formattedMinute = minute.toString().padStart(2, "0");
            times.push("".concat(formattedHour, ":").concat(formattedMinute));
        }
    }
    return times;
};


/***/ }),

/***/ 37895:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__KuEfj","chevronButton":"styles_chevronButton__4e2gT","disabled":"styles_disabled__4LPZY","pageContainer":"styles_pageContainer__gYvTx","pageActiveContainer":"styles_pageActiveContainer__eZ1cx","ellipsis":"styles_ellipsis__wEdbC"};

/***/ }),

/***/ 70405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__lJQ30","picture":"styles_picture__adXba","bannerImage":"styles_bannerImage__Ljw3Z"};

/***/ }),

/***/ 55568:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ue2_K","dataContainer":"styles_dataContainer__VMXmX","carouselContainer":"styles_carouselContainer__rIXhg","photoContainer":"styles_photoContainer__ZymvB","infoContainer":"styles_infoContainer__rQtME","arrowButtonLeft":"styles_arrowButtonLeft__n_gi_","arrowButtonRight":"styles_arrowButtonRight__Gj3us","spaceName":"styles_spaceName__H7_ec","row":"styles_row__WL5NK","nearbyStationContainer":"styles_nearbyStationContainer__8XsfT","distanceFromStation":"styles_distanceFromStation__55Wbl","businessHours":"styles_businessHours__YYgyz","spaceCapacity":"styles_spaceCapacity__6NZ_B","capacityContainer":"styles_capacityContainer__mdETS","availabilityContainer":"styles_availabilityContainer__UuSIo","availabilityTitle":"styles_availabilityTitle__OyIFm","availabilityList":"styles_availabilityList__RBeki","availability":"styles_availability__bRI78","saturday":"styles_saturday__lnBPC","sunday":"styles_sunday__GgAM_","buttonContainer":"styles_buttonContainer__13wao","reserveButtonLink":"styles_reserveButtonLink__z2XwC","reserveButton":"styles_reserveButton__EQB0I"};

/***/ }),

/***/ 63267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","stepper":"LuggageButtonComponent_stepper__wr_WK","countDownButton":"LuggageButtonComponent_countDownButton__a9FDt","countUpButton":"LuggageButtonComponent_countUpButton__1WnK1","count":"LuggageButtonComponent_count__KYmL0"};

/***/ }),

/***/ 51323:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","prev":"DateRangeCalendarSimpleComponent_prev__bSguo","next":"DateRangeCalendarSimpleComponent_next__2n_Mf","specifiedTime":"DateRangeCalendarSimpleComponent_specifiedTime__yNMun","specifiedTimeButton":"DateRangeCalendarSimpleComponent_specifiedTimeButton__GigVK","specifiedTimeButtonText":"DateRangeCalendarSimpleComponent_specifiedTimeButtonText__AqqDI","arrowIcon":"DateRangeCalendarSimpleComponent_arrowIcon__MFvtE"};

/***/ }),

/***/ 23398:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","link":"AreaCard_link__uUpwG","linkText":"AreaCard_linkText__LEyga"};

/***/ }),

/***/ 18188:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","planCard":"PlanCard_planCard__B0fOp","planCardImage":"PlanCard_planCardImage__qn5yt","planCardInfoTitle":"PlanCard_planCardInfoTitle__Ce5OT","planCardInfoPrice":"PlanCard_planCardInfoPrice__G_Uor","planCardInfoPriceAmount":"PlanCard_planCardInfoPriceAmount__XnyUG","planCardInfoPriceDay":"PlanCard_planCardInfoPriceDay__0AaHR","planCardInfoDescription":"PlanCard_planCardInfoDescription__eeG8_"};

/***/ }),

/***/ 90219:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","coinLockerCard":"RecommendedCoinLockerCard_coinLockerCard__pARvd","coinLockerCardTitle":"RecommendedCoinLockerCard_coinLockerCardTitle__5SJnM","coinLockerCardPhotoSection":"RecommendedCoinLockerCard_coinLockerCardPhotoSection__Z5yEf","coinLockerCardPhotoListArrow":"RecommendedCoinLockerCard_coinLockerCardPhotoListArrow__DkTEx","coinLockerCardPhotoListArrowLeft":"RecommendedCoinLockerCard_coinLockerCardPhotoListArrowLeft__ZVhpy","coinLockerCardPhotoListArrowRight":"RecommendedCoinLockerCard_coinLockerCardPhotoListArrowRight__2_ndm","coinLockerCardPhotoImage":"RecommendedCoinLockerCard_coinLockerCardPhotoImage__cHLM8","coinLockerCardContent":"RecommendedCoinLockerCard_coinLockerCardContent__H7WBY","coinLockerCardContentLink":"RecommendedCoinLockerCard_coinLockerCardContentLink__tpTMh","coinLockerCardDistanceTime":"RecommendedCoinLockerCard_coinLockerCardDistanceTime__cCyjZ","coinLockerCardDistanceTimeText":"RecommendedCoinLockerCard_coinLockerCardDistanceTimeText__IreSc","coinLockerCardDistanceTimeImage":"RecommendedCoinLockerCard_coinLockerCardDistanceTimeImage__Lsb6J","coinLockerCardNoteComment":"RecommendedCoinLockerCard_coinLockerCardNoteComment__rtULU","coinLockerCardNoteCommentText":"RecommendedCoinLockerCard_coinLockerCardNoteCommentText__gLkdf","coinLockerCardPriceSize":"RecommendedCoinLockerCard_coinLockerCardPriceSize__AU3Qb","coinLockerCardPriceSizeLink":"RecommendedCoinLockerCard_coinLockerCardPriceSizeLink__udS6d","coinLockerCardPriceSizeTitle":"RecommendedCoinLockerCard_coinLockerCardPriceSizeTitle__5__RJ","coinLockerCardPriceSizeTitleLink":"RecommendedCoinLockerCard_coinLockerCardPriceSizeTitleLink__VDJuG","coinLockerCardPriceSizeTitleIcon":"RecommendedCoinLockerCard_coinLockerCardPriceSizeTitleIcon__eJurf","coinLockerCardPriceSizeTitleImage":"RecommendedCoinLockerCard_coinLockerCardPriceSizeTitleImage__O9_D7","coinLockerCardPriceSizeDescription":"RecommendedCoinLockerCard_coinLockerCardPriceSizeDescription__lIfDv","coinLockerCardPriceSizeDescriptionLink":"RecommendedCoinLockerCard_coinLockerCardPriceSizeDescriptionLink__MHcIn","coinLockerCardPriceSizeNumberPrice":"RecommendedCoinLockerCard_coinLockerCardPriceSizeNumberPrice__akFDl","coinLockerCardPayment":"RecommendedCoinLockerCard_coinLockerCardPayment__1dOQh","coinLockerCardPaymentLink":"RecommendedCoinLockerCard_coinLockerCardPaymentLink__JFOKC","coinLockerCardPaymentTitle":"RecommendedCoinLockerCard_coinLockerCardPaymentTitle__qwdIn","coinLockerCardPaymentDescription":"RecommendedCoinLockerCard_coinLockerCardPaymentDescription__H4eaF","coinLockerCardReserve":"RecommendedCoinLockerCard_coinLockerCardReserve__MK1Bo","coinLockerCardReserveButton":"RecommendedCoinLockerCard_coinLockerCardReserveButton__UWcKP","coinLockerCardReserveButtonLink":"RecommendedCoinLockerCard_coinLockerCardReserveButtonLink__WhVHs","coinLockerCardReserveButtonOld":"RecommendedCoinLockerCard_coinLockerCardReserveButtonOld___UaXI"};

/***/ }),

/***/ 97019:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","listItem":"RecommendedCoinLockerCardList_listItem__TJvJZ","listWithGap":"RecommendedCoinLockerCardList_listWithGap__oAocB","noDataText":"RecommendedCoinLockerCardList_noDataText__w5Zcr","container":"RecommendedCoinLockerCardList_container___j4YC"};

/***/ }),

/***/ 59743:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","spaceCard":"RecommendedSpaceCard_spaceCard__uFBmw","spaceCardTitle":"RecommendedSpaceCard_spaceCardTitle__XPUe2","spaceCardTitleLink":"RecommendedSpaceCard_spaceCardTitleLink__GSMee","spaceCardMainImage":"RecommendedSpaceCard_spaceCardMainImage__D9bE0","spaceCardMainImageListArrow":"RecommendedSpaceCard_spaceCardMainImageListArrow__DgqDN","spaceCardMainImageListArrowLeft":"RecommendedSpaceCard_spaceCardMainImageListArrowLeft__m3q88","spaceCardMainImageListArrowRight":"RecommendedSpaceCard_spaceCardMainImageListArrowRight__t8uLs","spaceCardMainImageImage":"RecommendedSpaceCard_spaceCardMainImageImage__Rpx0i","spaceCardDistanceTime":"RecommendedSpaceCard_spaceCardDistanceTime__7fi0a","spaceCardDistanceTimeText":"RecommendedSpaceCard_spaceCardDistanceTimeText__t3rCv","spaceCardDistanceTimeImage":"RecommendedSpaceCard_spaceCardDistanceTimeImage__LfIBr","spaceCardReview":"RecommendedSpaceCard_spaceCardReview___MS1a","spaceCardReviewData":"RecommendedSpaceCard_spaceCardReviewData__uUq6E","spaceCardReviewDataAverage":"RecommendedSpaceCard_spaceCardReviewDataAverage__kfCBo","spaceCardReviewDataTotal":"RecommendedSpaceCard_spaceCardReviewDataTotal__THxdH","spaceCardReviewComment":"RecommendedSpaceCard_spaceCardReviewComment__t72l0","spaceCardReviewCommentText":"RecommendedSpaceCard_spaceCardReviewCommentText__j_K5n","spaceCardContent":"RecommendedSpaceCard_spaceCardContent__cs0JV","spaceCardContentLink":"RecommendedSpaceCard_spaceCardContentLink__8M5xA","spaceCardSize":"RecommendedSpaceCard_spaceCardSize__Kl1Hb","spaceCardSizeTitle":"RecommendedSpaceCard_spaceCardSizeTitle__PZLsE","spaceCardSizeTitleLink":"RecommendedSpaceCard_spaceCardSizeTitleLink__Vi7S0","spaceCardSizeTitleIcon":"RecommendedSpaceCard_spaceCardSizeTitleIcon__99HSO","spaceCardSizeTitleImage":"RecommendedSpaceCard_spaceCardSizeTitleImage__kJIUL","spaceCardSizeDescriptionLink":"RecommendedSpaceCard_spaceCardSizeDescriptionLink__LnsPB","spaceCardSizeSizePopUp":"RecommendedSpaceCard_spaceCardSizeSizePopUp__mDV2g","spaceCardSizeSizePopUpClose":"RecommendedSpaceCard_spaceCardSizeSizePopUpClose__NI6Gf","spaceCardSizeInfo":"RecommendedSpaceCard_spaceCardSizeInfo__NBr5G","spaceCardSizeInfoImage":"RecommendedSpaceCard_spaceCardSizeInfoImage__yffXu","spaceCardSizeInfoSize":"RecommendedSpaceCard_spaceCardSizeInfoSize__vaKGx","spaceCardReserve":"RecommendedSpaceCard_spaceCardReserve__ftqGA","spaceCardReserveButton":"RecommendedSpaceCard_spaceCardReserveButton__MWgp_","spaceCardReserveButtonLink":"RecommendedSpaceCard_spaceCardReserveButtonLink__7V5en","spaceCardEmpty":"RecommendedSpaceCard_spaceCardEmpty__DE3iK","spaceCardEmptyLink":"RecommendedSpaceCard_spaceCardEmptyLink__4jqiM","spaceCardEmptyTitle":"RecommendedSpaceCard_spaceCardEmptyTitle__OGfeW","spaceCardEmptyCalendarTable":"RecommendedSpaceCard_spaceCardEmptyCalendarTable__CA1ES","spaceCardEmptyCalendarTableItem":"RecommendedSpaceCard_spaceCardEmptyCalendarTableItem__oF7FJ","spaceCardEmptyCalendarTableLabel":"RecommendedSpaceCard_spaceCardEmptyCalendarTableLabel__NUI5D","spaceCardEmptyCalendarTableLabelText":"RecommendedSpaceCard_spaceCardEmptyCalendarTableLabelText__P_CdZ","spaceCardEmptyCalendarTableTh":"RecommendedSpaceCard_spaceCardEmptyCalendarTableTh__V0Uj_","spaceCardEmptyCalendarTableThSaturday":"RecommendedSpaceCard_spaceCardEmptyCalendarTableThSaturday__AQXdY","spaceCardEmptyCalendarTableThSunday":"RecommendedSpaceCard_spaceCardEmptyCalendarTableThSunday__QvMq8","spaceCardEmptyCalendarTableDate":"RecommendedSpaceCard_spaceCardEmptyCalendarTableDate__mNY1x","spaceCardEmptyCalendarTableTd":"RecommendedSpaceCard_spaceCardEmptyCalendarTableTd__iNUjF","spaceCardEmptyCalendarTableTdIcon":"RecommendedSpaceCard_spaceCardEmptyCalendarTableTdIcon__G8_xb","spaceCardEmptyCalendarTableTdLabel":"RecommendedSpaceCard_spaceCardEmptyCalendarTableTdLabel__fQScx","spaceCardInfoItems":"RecommendedSpaceCard_spaceCardInfoItems__rQGm6","spaceCardInfoItemSizePopUp":"RecommendedSpaceCard_spaceCardInfoItemSizePopUp__wZso_","spaceCardInfoItemSizePopUpClose":"RecommendedSpaceCard_spaceCardInfoItemSizePopUpClose__JAUCB","spaceCardInfoItemSizePopUpCloseButton":"RecommendedSpaceCard_spaceCardInfoItemSizePopUpCloseButton__yALaS","spaceCardInfoItemSizePopUpOpen":"RecommendedSpaceCard_spaceCardInfoItemSizePopUpOpen___dW2w"};

/***/ }),

/***/ 87727:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","listItem":"RecommendedSpaceCardList_listItem__1LIDf","button":"RecommendedSpaceCardList_button__D9fiC","buttonWrap":"RecommendedSpaceCardList_buttonWrap__nKO5n","buttonLoading":"RecommendedSpaceCardList_buttonLoading__U1b0M","noDataText":"RecommendedSpaceCardList_noDataText__LjXSN","loading":"RecommendedSpaceCardList_loading__udBZE","totalCount":"RecommendedSpaceCardList_totalCount__OojZD","totalCountText":"RecommendedSpaceCardList_totalCountText__9YOnI","totalCountNumber":"RecommendedSpaceCardList_totalCountNumber__ikizl"};

/***/ }),

/***/ 22165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","blockTitle":"AccordionBlock_blockTitle__DIMab","blockTitleText":"AccordionBlock_blockTitleText__ij2UF","blockContent":"AccordionBlock_blockContent__F7AVp","blockContentActive":"AccordionBlock_blockContentActive__9mwpL","accordionIcon":"AccordionBlock_accordionIcon__jQUYM"};

/***/ }),

/***/ 64984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","section":"CoinLockerMapSection_section__AryrY"};

/***/ }),

/***/ 85985:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","searchContainer":"SearchForm_searchContainer__qhc0s","searchInput":"SearchForm_searchInput__Mef7I","searchInputForm":"SearchForm_searchInputForm__kRcgn","searchInputFormWrap":"SearchForm_searchInputFormWrap___hH_E","searchInputArea":"SearchForm_searchInputArea__q_qx2","searchInputAreaIcon":"SearchForm_searchInputAreaIcon__gK8uD","searchInputAreaForm":"SearchForm_searchInputAreaForm__MwQPR","searchInputDateSizeCount":"SearchForm_searchInputDateSizeCount__NkrDp","searchInputDate":"SearchForm_searchInputDate__24_WO","searchInputDateImage":"SearchForm_searchInputDateImage__7wnc_","searchInputSizeCount":"SearchForm_searchInputSizeCount__mszwY","searchInputSizeCountBag":"SearchForm_searchInputSizeCountBag__9CaZa","searchInputSizeCountSuitcase":"SearchForm_searchInputSizeCountSuitcase__G5E3n","searchInputSizeCountBagImage":"SearchForm_searchInputSizeCountBagImage__mT5IA","searchInputSizeCountSuitcaseImage":"SearchForm_searchInputSizeCountSuitcaseImage__LHeqF","luggageContainer":"SearchForm_luggageContainer__bj5sg","luggageContainerBagSize":"SearchForm_luggageContainerBagSize___hVdj","luggageContainerSuitecaseSize":"SearchForm_luggageContainerSuitecaseSize__T0aSg","counter":"SearchForm_counter__oNe2M","counterLabel":"SearchForm_counterLabel__mALnq","description":"SearchForm_description__7Du_i","searchButtonWrap":"SearchForm_searchButtonWrap__V_SEm","searchButton":"SearchForm_searchButton__l4rT1","searchButtonDisabled":"SearchForm_searchButtonDisabled__KjZ6Z","suggest":"SearchForm_suggest__IvW4n","noResult":"SearchForm_noResult__5Vm9N","suggestText":"SearchForm_suggestText__sP3VV","noResultText":"SearchForm_noResultText___l8ZU"};

/***/ }),

/***/ 7598:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","list":"FacilityCardList_list__eLpst","listItem":"FacilityCardList_listItem__ixnKN"};

/***/ }),

/***/ 42427:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","sectionContainer":"FacilityRecommendationsSection_sectionContainer__Wag6i","section":"FacilityRecommendationsSection_section__pifh1","sectionOther":"FacilityRecommendationsSection_sectionOther__p_eUG","sectionOtherLink":"FacilityRecommendationsSection_sectionOtherLink__NZ2EE"};

/***/ }),

/***/ 97603:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","qa":"Qa_qa__bgqAY","qaTitle":"Qa_qaTitle__BG0_b","qaList":"Qa_qaList__9sExA","qaListItem":"Qa_qaListItem__IYXIG","qaListItemQuestion":"Qa_qaListItemQuestion__UaRIL","qaListItemQuestionTrigger":"Qa_qaListItemQuestionTrigger__2C6Xc","accordionIcon":"Qa_accordionIcon__qqyt5","qaListItemAnswer":"Qa_qaListItemAnswer__XPu7G","link":"Qa_link__lpE3c","qaListItemContent":"Qa_qaListItemContent__8n1HY","qaListItemContentMark":"Qa_qaListItemContentMark__3Vd83","qaListItemContentTitle":"Qa_qaListItemContentTitle__3cQFc","qaListItemContentDesc":"Qa_qaListItemContentDesc__VmduT"};

/***/ }),

/***/ 33030:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","ownerSection":"OwnerSection_ownerSection__TbJqM","ownerSectionBox":"OwnerSection_ownerSectionBox__I1viM","ownerSectionBoxTitle":"OwnerSection_ownerSectionBoxTitle__4KwcT","ownerSectionBoxButton":"OwnerSection_ownerSectionBoxButton__UEErN"};

/***/ }),

/***/ 87483:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","loading":"LoadingComponent_loading__kFLsY","loadingObject":"LoadingComponent_loadingObject__B49CA","loop":"LoadingComponent_loop__UphdY"};

/***/ }),

/***/ 3667:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","ratingBox":"RatingCustomComponent_ratingBox__UmxKE","ratingStar":"RatingCustomComponent_ratingStar__A_3iI","ratingBackground":"RatingCustomComponent_ratingBackground__EA3q8","ratingBackgroundStar":"RatingCustomComponent_ratingBackgroundStar__Cjp2d","ratingForeground":"RatingCustomComponent_ratingForeground__ZgjrD","ratingForegroundStar":"RatingCustomComponent_ratingForegroundStar__joKxf"};

/***/ }),

/***/ 30540:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","card":"CardStore_card__zjjaQ","cardInfo":"CardStore_cardInfo__fKKIi","cardTitle":"CardStore_cardTitle__oHnC2","cardBanner":"CardStore_cardBanner__Q6Qv7","cardImage":"CardStore_cardImage__TTOFg"};

/***/ }),

/***/ 42069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","title":"SectionBottomBorderTitle_title__reucU","titleText":"SectionBottomBorderTitle_titleText__R4upS"};

/***/ }),

/***/ 97281:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","sectionContainer":"Slug_sectionContainer__MoEK1","mainVisualSection":"Slug_mainVisualSection__oX0XT","mainVisualSectionShare":"Slug_mainVisualSectionShare__1k6j_","mainVisualSectionShareButton":"Slug_mainVisualSectionShareButton__iAP7B","mainVisualSectionTitle":"Slug_mainVisualSectionTitle__j_sIe","mainVisualSectionNoneBg":"Slug_mainVisualSectionNoneBg__EqYQE","pseudoElement":"Slug_pseudoElement__c8umj","searchSection":"Slug_searchSection__PHKuN","searchSectionNoneBg":"Slug_searchSectionNoneBg__CVUrL","updatedAtSection":"Slug_updatedAtSection__vovYT","updatedAtText":"Slug_updatedAtText__Kgltv","tabSection":"Slug_tabSection__W3eJs","tabMenus":"Slug_tabMenus__Feni1","tabMenu":"Slug_tabMenu__Kko2D","tabMenuTitle":"Slug_tabMenuTitle___XbYL","tabMenuActive":"Slug_tabMenuActive__26pkt","tabContents":"Slug_tabContents__qm8bJ","tabContent":"Slug_tabContent__Chnzi","tabContentActive":"Slug_tabContentActive__cj_T6","shareSection":"Slug_shareSection___Ekh3","pageDescriptionSection":"Slug_pageDescriptionSection__dm_ff","pageDescriptionSectionText":"Slug_pageDescriptionSectionText__H0iev","aboutServiceSection":"Slug_aboutServiceSection__YxlDt","aboutServiceSectionTitle":"Slug_aboutServiceSectionTitle__7jACv","aboutServiceSectionTitleText":"Slug_aboutServiceSectionTitleText__3Xgwi","aboutServiceSectionFeature":"Slug_aboutServiceSectionFeature__g_YOV","aboutServiceSectionFeatureItem":"Slug_aboutServiceSectionFeatureItem__iDAjv","aboutServiceSectionFeatureItemText":"Slug_aboutServiceSectionFeatureItemText__ftueN","aboutServiceSectionDescription":"Slug_aboutServiceSectionDescription__Mf8CN","features":"Slug_features__EoJff","aboutServiceSectionButtons":"Slug_aboutServiceSectionButtons__40yja","aboutServiceSectionButton":"Slug_aboutServiceSectionButton__AyY_W","popularSection":"Slug_popularSection__5Ysmp","popularSectionOther":"Slug_popularSectionOther__uuF5q","popularSectionOtherLink":"Slug_popularSectionOtherLink__YE32n","recommendedSection":"Slug_recommendedSection__pYvZy","recommendedSectionSectionTitleSubElement":"Slug_recommendedSectionSectionTitleSubElement__bf2_N","recommendedSectionSectionTitleSubElementImage":"Slug_recommendedSectionSectionTitleSubElementImage__RYXKj","recommendedSectionSectionTitleSubElementText":"Slug_recommendedSectionSectionTitleSubElementText__Uj1OW","recommendedSectionFilters":"Slug_recommendedSectionFilters__bfQuQ","recommendedSectionFilterButton":"Slug_recommendedSectionFilterButton__uzSJk","recommendedSectionFilterButtonActive":"Slug_recommendedSectionFilterButtonActive__PiLhw","featureSection":"Slug_featureSection__0ndPs","featureList":"Slug_featureList__TpS5V","featureListItem":"Slug_featureListItem___aHqs","featureInfoIcon":"Slug_featureInfoIcon__FtV05","featureInfoTitle":"Slug_featureInfoTitle__hQMNV","featureInfoDescription":"Slug_featureInfoDescription__9N0Fe","howToUseSection":"Slug_howToUseSection__TLwBd","howToUseSectionTitle":"Slug_howToUseSectionTitle__AOOLu","howToUseList":"Slug_howToUseList___2sDT","howToUseInfo":"Slug_howToUseInfo__VFhfl","howToUseInfoVisual":"Slug_howToUseInfoVisual__PC62H","howToUseInfoTitle":"Slug_howToUseInfoTitle__pJ3rp","planSection":"Slug_planSection__gD0fP","planList":"Slug_planList__kT7zw","planListItem":"Slug_planListItem__Zvc3l","qaSection":"Slug_qaSection__itBi3","wikiSection":"Slug_wikiSection__3__gt","wikiSectionText":"Slug_wikiSectionText__nRXLp","storeSection":"Slug_storeSection__y2bnT","noticeSection":"Slug_noticeSection__hjY6Y","title":"Slug_title__YcAxr","locationSection":"Slug_locationSection__vWMdK","mainVisualSectionShareButtonImage":"Slug_mainVisualSectionShareButtonImage__gCVib","tabMenuIcon":"Slug_tabMenuIcon__KH4g7","shareSectionContainer":"Slug_shareSectionContainer__qn8AG","recommendedCoinLockerSectionSectionTitleSubElement":"Slug_recommendedCoinLockerSectionSectionTitleSubElement__BWCNx","howToUseListItem":"Slug_howToUseListItem__Rkhi5"};

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 25054:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/iconsManifest.mjs
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "MIT",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/iconContext.mjs

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && /*#__PURE__*/react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/iconBase.mjs
var _excluded = ["attr", "size", "title"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function Tree2Element(tree) {
  return tree && tree.map((node, i) => /*#__PURE__*/react.createElement(node.tag, _objectSpread({
    key: i
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  return props => /*#__PURE__*/react.createElement(IconBase, _extends({
    attr: _objectSpread({}, data.attr)
  }, props), Tree2Element(data.child));
}
function IconBase(props) {
  var elem = conf => {
    var {
        attr,
        size,
        title
      } = props,
      svgProps = _objectWithoutProperties(props, _excluded);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return /*#__PURE__*/react.createElement("svg", _extends({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: _objectSpread(_objectSpread({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /*#__PURE__*/react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? /*#__PURE__*/react.createElement(IconContext.Consumer, null, conf => elem(conf)) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/index.mjs




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4396,3365,1664,1423,1580,9882,5769,1336,2948,1909,9774,2888,179], function() { return __webpack_exec__(87156); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);